<template>
  <div>
    <jd-dialog
      title="选择奖品"
      :visible.sync="dialogVisibleFrom"
      :width="jingduoForm.cycleType == 1 ? '1200px' : '1100px'"
      append-to-body
      center
      @close="dialogClose"
      :isShowCancel="false"
      :isShowSure="false"
    >
      <div style="position: relative">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            label="优惠券"
            v-if="isShowCoupon && (!isShowFirst || onlyShowFirst)"
            name="first"
          >
            <div>
              <!-- <input-form
                ref="inputForms"
                :inputData="inputDataTwo"
                :btnPosition1="true"
                @toParentVal="searchContentTwo"
              ></input-form> -->
              <jd-form
                ref="inputForms"
                :form-info="inputDataTwo"
                @search="searchContentTwo"
              />
              <div style="margin: 16px 0px 10px 0">
                <jd-button v-if="venderType" @click="handleAddCoupon2"
                  >添加发放型外部券</jd-button
                >
                <jd-button v-else @click="handleAddCoupon"
                  >创建发放型优惠券</jd-button
                >
              </div>
              <div class="coupon-tip-wrap">
                <jd-tip>
                  <p>因官方接口限制，FCS店铺不支持优惠券奖品，请勿使用优惠券</p>
                </jd-tip>
              </div>
              <jd-table
                :tableData="externalTable"
                :loading="tableLoading"
                :pageInfo="{
                  pageNum: formListTwo.current,
                  pageSize: formListTwo.size,
                  total: totalNumTwo,
                }"
                @handlePage="handlePageChangeTwo"
              >
                <el-table-column prop="name" label="优惠券名称" width="150">
                </el-table-column>
                <el-table-column
                  prop="couponKind"
                  label="优惠券信息"
                  width="150"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.couponKind == 0">全品类东券,</span>
                    <span v-if="scope.row.couponKind == 1">限品类京券,</span>
                    <span v-if="scope.row.couponKind == 2">店铺东券,</span>
                    <span v-if="scope.row.couponKind == 3">限商品东券,</span>
                    满{{ scope.row.quota }}减{{ scope.row.discount }}元
                  </template>
                </el-table-column>
                <el-table-column
                  :prop="venderType ? 'putkey' : 'couponIdOrPutKey'"
                  label="优惠券id/key"
                  width="120"
                >
                </el-table-column>

                <el-table-column prop="createTime" label="创建时间" width="180">
                </el-table-column>
                <el-table-column label="领取时间" width="180">
                  <template slot-scope="scope">
                    <span>起:{{ scope.row.takeBeginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.takeEndTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="canUseBalanceNum" label="可用优惠券数量" width="120">
                </el-table-column>
                <el-table-column prop="balanceNum" label="剩余数量" width="100">
                </el-table-column>
                <el-table-column
                  prop="numPerSending"
                  label="单次发放数量"
                  width="120"
                >
                </el-table-column>
                <el-table-column prop="status" label="奖品状态" width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row.status == 1">未开始</span>
                    <span v-if="scope.row.status == 2">进行中</span>
                    <span v-if="scope.row.status == 3">已结束</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="70">
                  <template slot-scope="scope">
                    <jd-button
                      :disabled="selectedCouponId == scope.row.assetsId"
                      type="blueText"
                      @click="chooseTab(scope.row)"
                    >
                      {{ selectedCouponId == scope.row.assetsId ? '已选择' : '选择' }}
                    </jd-button>
                  </template>
                </el-table-column>
              </jd-table>
              <!-- <el-pagination
                style="text-align: right; margin-top: 20px"
                @size-change="handleSizeChangeTwo"
                background
                @current-change="handleCurrentChangeTwo"
                :page-sizes="[10, 20, 30, 50, 100, 500]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNumTwo"
                :current-page="1"
              ></el-pagination> -->
              <div style="color: #fe4d45; padding: 20px 0 20px 40px">
                <!-- 注：此类型奖品暂时不支持自营店铺 -->
              </div>
              <div class="flexc">
                <span class="label-style">去使用链接：</span>
                <div>
                  <el-radio-group v-model="prizeGoShop.goShopSetting"  @change="onShopSetChange">
                    <el-radio :label="0">进入店铺首页</el-radio>
                    <el-radio :label="1">跳转指定小程序</el-radio>
                    <el-radio :label="2">进入指定链接</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div v-if="prizeGoShop.goShopSetting == 1" class="mt16">
                <div class="flex-x-start">
                  <div class="label-style">
                    <span class="req-style">*</span> 
                    小程序appId：
                  </div>
                  <el-input
                    type="textarea"
                    placeholder="请输入小程序appId"
                    style="width: 425px; margin-left: 8px"
                    show-word-limit
                    v-model="prizeGoShop.goShopAppId"
                    :maxlength="1000"
                  ></el-input>
                </div>
                <div class="flex-x-start mt16">
                  <span class="label-style">页面路径path：</span>
                  <el-input
                    type="textarea"
                    placeholder="请输入小程序页面路径path"
                    style="width: 425px; margin-left: 8px"
                    show-word-limit
                    v-model="prizeGoShop.goShopUrl"
                    :maxlength="1000"
                  ></el-input>
                </div>
                <div class="link-tip">
                  注意：path若不写，则默认进入小程序主页。
                </div>
              </div>
              <div
                v-if="prizeGoShop.goShopSetting == 2"
                class="flex-x-start mt16"
              >
                <div class="label-style">
                  <span class="req-style">*</span>
                  指定链接：
                </div>
                <el-input
                  type="textarea"
                  placeholder="请输入指定链接"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="prizeGoShop.goShopUrl"
                  :maxlength="1000"
                ></el-input>
              </div>
              <div class="link-tip" v-if="prizeGoShop.goShopSetting == 2">
                注意：仅可填写京东域内的
                H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
              </div>
            </div>
            <div style="display: flex; justify-content: end">
              <jd-button
                type="blue"
                :disabled="!couponObj.id||((prizeGoShop.goShopSetting == 1&&!prizeGoShop.goShopAppId)||(prizeGoShop.goShopSetting == 2&&!prizeGoShop.goShopUrl))"
                @click="handleSubmitCoupon"
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="京豆"
            v-if="isShowJingdou && !onlyShowFirst"
            :disabled="jdActual"
            name="second"
          >
            <div style="height: 24px"></div>
            <el-form
              ref="jingduoForm:"
              :model="jingduoForm"
              :label-width="!isATwoPrice ? '100px' : '155px'"
            >
              <el-form-item label="奖品图:">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="secondLogo"
                        :src="secondLogo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="
                      secondLogo =
                        'https://cdn-image.yucrm.cn/5a6fc854abbd4a4882def758d8f578f4.png'
                    "
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="活动周期:" v-if="actType== 68">
                <div class="flex-box">
                  <el-radio-group v-model="jingduoForm.cycleType" @change="changeCycleType">
                    <el-radio :label="0">活动时长90天内</el-radio>
                    <el-radio :label="1">活动时长大于90天</el-radio>
                  </el-radio-group>
                  <el-popover
                    placement="top"
                    width="400"
                    trigger="hover"
                    style="margin-left: 8px;margin-top: 4px;"
                  >
                    <div>
                      <div>
                        活动周期=活动开始时间-活动结束时间的总时长；
                      </div>
                      <div>
                        1、活动时长90天内：即仅需配置一个京豆计划即够活动周期内发放京豆（单个京豆计划最多仅可配置90天）
                      </div>
                      <div>
                        2、活动时长大于90天：需根据活动所需配置多个京豆计划，排序最后的一个京豆计划结束时间需大于活动结束时间，配置完成后，会根据排序使用京豆计划发放京豆奖品，直至排序靠前的京豆计划有效期结束，就开始使用下一个京豆计划发放奖品；
                      </div>
                    </div>
                    <div class="question-icon" slot="reference">
                      <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/icon-question.png" alt="" />
                    </div>
                  </el-popover>
                </div>
              </el-form-item>
              <el-form-item label="选择京豆计划:" v-if="jingduoForm.cycleType== 0">
                <el-select
                  v-model="accountCode"
                  placeholder="请选择"
                  style="margin-right: 8px"
                  v-if="venderType"
                  :disabled="isEditList[activeName]"
                >
                  <el-option
                    v-for="item in accountCodeList"
                    :key="item.accountCode"
                    :label="item.accountCode"
                    :value="item.accountCode"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="jingduoForm.region"
                  placeholder="请选择"
                  @change="planChange"
                  style="width: 215px"
                  :disabled="isEditList[activeName]"
                >
                  <el-option
                    v-for="(item, index) in selectList"
                    :key="index"
                    :label="item.label"
                    :value="item"
                  ></el-option>
                </el-select>
                <jd-button
                  type="blueText"
                  style="margin: 0px 8px"
                  @click="getJingdouList"
                  :disabled="isEditList[activeName]"
                  >刷新</jd-button
                >
                <jd-button
                  style="width: auto"
                  type="blue"
                  @click="jumpJingduo"
                  :disabled="isEditList[activeName]"
                  >创建京豆计划</jd-button
                >
                <div v-show="activeSendtimes">
                  <span>京豆计划的发豆次数，最多</span>
                  <span style="color: #fe4d45"> {{ activeSendtimes }} </span
                  >次，
                  <span
                    >剩余金豆预算额<span style="color: #fe4d45">{{
                      jingduoForm.region.budgetRemain
                    }}</span
                    >个</span
                  >
                </div>
              </el-form-item>
              <el-form-item label="单份奖励个数:" v-if="jingduoForm.cycleType== 0">
                <el-input
                  v-model="jingduoForm.count"
                  @input="jingduoForm.count = checkputn($event)"
                  style="width: 215px"
                  :disabled="isEditList[activeName]"
                ></el-input>
                <span> 个京豆 （每人每次发送的京豆个数）</span>
              </el-form-item>
              <div v-if="jingduoForm.cycleType == 1" class="mb16">
                  <jd-table 
                  :tableInfo="jdTableInfo"
                  :tableData="jingduoForm.bindPlanList">
                    <template #nameSlot="{ row }">
                      <el-select
                        v-model="row.accountCode"
                        placeholder="请选择"
                        class="sel-w"
                        style="margin-right: 8px"
                        v-if="venderType"
                        :disabled="isEditList[activeName]"
                        @change="(val) => handleRowAccountCodeChange(val, row)"
                      >
                        <el-option
                          v-for="item in accountCodeList"
                          :key="item.accountCode"
                          :label="item.accountCode"
                          :value="item.accountCode"
                        >
                        </el-option>
                      </el-select>
                      <el-select
                        v-model="row.id"
                        placeholder="请选择"
                        class="sel-w"
                        :disabled="isEditList[activeName]"
                        @change="(val) => handleSelectJduoChange(row, val)"
                      >
                        <el-option
                          v-for="(item, index) in selectList"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                          :disabled="jingduoForm.bindPlanList.some((plan) => plan.id === item.id && plan !== row)"
                        ></el-option>
                      </el-select>
                    </template>
                    <template #palnTimeSlot="{ row }">
                      <div>起：{{ row.startTime }}</div>
                      <div>止：{{ row.endTime }}</div>
                    </template>
                    <template #useTimeSlot="{ row,rowIndex }">
                      <div class="time-box">
                        <div class="flex-box">
                          <span>起：</span>
                            <el-date-picker
                              v-model="row.useStartTime"
                              prefix-icon="no_icon"
                              type="datetime"
                              placeholder="使用开始时间"
                              size="small"
                              format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              :picker-options="getUseStartPickerOptions(row)"
                              @change="handleUseStartTimeChange(row)"
                            ></el-date-picker>
                        </div>
                        <div class="flex-box mt8">
                          <span>止：</span>
                            <el-date-picker
                              v-model="row.useEndTime"
                              prefix-icon="no_icon"
                              type="datetime"
                              placeholder="使用结束时间"
                              size="small"
                              format="yyyy-MM-dd HH:mm:ss"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              :picker-options="getUseEndPickerOptions(row,rowIndex)"
                            ></el-date-picker>
                        </div>
                      </div>
                    </template>
                    <template #singleAmountSlot="{ row }">
                      <el-input
                        v-model="row.singleAmount"
                        placeholder="请输入"
                        @input="row.singleAmount = checkJdSingleIn($event, row)"
                        :disabled="isEditList[activeName]||!row.id"
                      ></el-input>
                    </template>
                    <template #totalAmountSlot="{ row }">
                      <el-input
                        v-model="row.totalAmount"
                        placeholder="请输入"
                        @input="row.totalAmount = checkJdTotalIn($event,row)"
                        :disabled="isEditList[activeName]||!row.id"
                      ></el-input>
                    </template>
                    <template #operationSlot="{ row ,rowIndex}">
                      <jd-button v-if="jingduoForm.bindPlanList.length>1" type="blueText" @click="handleDeleteJd(rowIndex)">删除</jd-button>
                    </template>
                  </jd-table>
                  <jd-button class="mt16" type="blue" @click="handleAddJd">增加计划（{{jingduoForm.bindPlanList.length}}/10）</jd-button>
              </div>
              <!-- A2奖品介绍 -->
              <el-form-item label="奖品介绍(用户端展示):" v-if="isATwoPrice">
                <div style="width: 570px; position: relative">
                  <richText
                    v-model="jingduoForm.introduceToUser"
                    :readOnly="false"
                    :maxLength="500"
                    :height="200"
                  >
                  </richText>
                </div>
              </el-form-item>
              <!-- <div style="color: red;margin-bottom: 20px;">请确保京豆计划的发放规则和活动中奖规则不冲突，否则可能会导致领取奖品失败，进而产生客诉。</div> -->
              <!-- <div
                style="color: red; margin-bottom: 20px"
                v-if="jingduoForm.count > 1000"
              >
                因官方接口限制，单次发豆数量上限是1000，超过时会分多次发放，为确保发放成功，京豆计划发放次数必大于等于单份奖励个数/1000
              </div> -->
              <jd-tip>
                <p>注：</p>
                <p>因官方接口限制，如选择的京豆计划单次发放类型上限为1000时，超过会多次发放，为确保发放成功，京豆计划发放次数必须大于等于单份奖励个数/1000；</p>
                <p>如需发放超过1000建议选择单次发放类型上限为50000的京豆计划，如超过50000，也会多次发放；</p>
              </jd-tip>
              <el-form-item style="margin-left: -100px"> </el-form-item>
            </el-form>
            <div class="topTis" v-if="venderType && !isOpenJinDou">
              <i
                class="el-icon-warning"
                style="color: #2768ff; marginright: 8px; font-size: 14px"
              ></i>
              <div class="desc" style="color: #666">
                <p>自营店铺京豆使用流程：</p>
                <p class="topTis_line">1、开通白名单、账号授权</p>
                <p class="topTis_line">
                  因京东平台对自营店铺充值有白名单限制，需要联系京东采销协助开通，请自营店铺在使用京豆前查看供应商充值操作流程。
                </p>
                <p
                  class="topTis_line"
                  style="color: #fe4d45; margin-bottom: 16px; cursor: pointer"
                  @click="toJdTeach"
                >
                  自营店铺京豆充值教程 >
                </p>
                <p class="topTis_line">2、绑定供应商简码、授权账号pin</p>
                <p class="topTis_line">
                  如果供应商白名单，账号授权已经完成，请点击绑定供应商简码、授权账号pin；
                </p>
                <p class="topTis_line">
                  绑定成功后需要重新进入活动页面，创建京豆计划。
                </p>
              </div>
            </div>
            <div style="display: flex; justify-content: end">
              <jd-button
                v-if="!disabled || isEditList[activeName]"
                type="blue"
                @click="
                  () => {
                    this.getJingdouData();
                    this.setJingdouData();
                  }
                "
                >确定</jd-button
              >
            </div>
            <!-- 无链接 产品说隐藏该按钮 -->
            <!-- <el-button class="cancel" @click="toBindJd">点击绑定京豆授权账号</el-button> -->
          </el-tab-pane>
          <el-tab-pane
            label="实物"
            v-if="isShowThing && !onlyShowFirst"
            :disabled="actual"
            name="third"
          >
          <div class="physical-box">
            <div style="margin-bottom: 15px">
              <jd-tip>
                <div>
                  选择此类型奖品时，用户满足获奖条件，领取奖品后，需要商家在当前系统手工发货，并在【实物奖品名单】中填写物流单号！
                </div>
              </jd-tip>
            </div>
            <el-form
              ref="objectForm"
              :model="objectForm"
              :label-width="!isATwoPrice ? '158px' : '168px'"
            >
              <el-form-item label="奖品来源:">
                <el-radio-group
                  v-model="objectForm.resource"
                  @change="cleanImg"
                >
                  <el-radio label="2">直接填写</el-radio>
                  <el-radio label="1">从店铺中选择</el-radio>
                  <el-radio label="3">从【实物管理】栏目选择</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-show="objectForm.resource == 2">
                <el-upload
                  ref="upload"
                  action="#"
                  list-type="picture-card"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
                  :http-request="httpRequest"
                  :file-list="fileList"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <!-- <el-dialog :visible.sync="dialogVisible" style="z-index:3050">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog> -->
                <span style="color: #fe4d45; font-size: 12px"
                  >建议尺寸：200*200像素，图片大小不能超过300K，类型：JPG、PNG</span
                >
              </el-form-item>
              <el-form-item v-if="objectForm.resource == 1">
                <div v-if="objectForm.logo && objectForm.resource == 1">
                  <img
                    :src="objectForm.logo"
                    alt=""
                    style="width: 150px; height: 150px"
                  />
                </div>
                <jd-button
                  @click="
                    dialogFormVisible = true;
                    getShopList();
                  "
                  style="width: 110px; text-align: center"
                  >选择店铺商品</jd-button
                >
              </el-form-item>
              <template v-if="objectForm.resource == 3">
                <el-form-item label="选择奖品:">
                  <el-select
                    v-model="physicalForm.region"
                    placeholder="请选择"
                    @change="handleChangePhysical"
                  >
                    <el-option
                      v-for="item in physicalList"
                      :key="item.id"
                      :label="item.label"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <jd-button
                    type="blueText"
                    style="margin: 0px 8px"
                    @click="resetPhysical"
                    >刷新</jd-button
                  >
                  <jd-button
                    style="margin-right: 8px"
                    type="blue"
                    @click="createPhysical"
                    >创建实物</jd-button
                  >
                  <p v-if="physicalForm.inventoryType == 1">不限库存</p>
                  <p v-else>
                    可用数量
                    <span
                      style="color: #fe4d45"
                      v-if="physicalForm.budgetRemain >= 0"
                      >{{ physicalForm.budgetRemain }}</span
                    >
                    <span v-else>--</span>
                    件
                  </p>
                </el-form-item>
                <el-form-item v-if="physicalForm.logo" label="">
                  <div>
                    <img
                      style="
                        width: 148px;
                        height: 148px;
                        border-radius: 6px;
                        overflow: hidden;
                      "
                      :src="physicalForm.logo"
                    />
                  </div>
                </el-form-item>
              </template>
              <el-form-item v-if="objectForm.resource != 3" label="奖品名称:">
                <el-input
                  v-model="objectForm.name"
                  :maxlength="isATwoPrice ? '20' : '12'"
                  show-word-limit
                  :style="{ width: isATwoPrice ? '330px' : '250px' }"
                ></el-input>
              </el-form-item>
              <el-form-item v-if="objectForm.resource != 3" label="奖品价值:">
                <el-input
                  v-model="objectForm.discount"
                  @keyup.native="limitInput($event)"
                  @blur="objectForm.discount = inputLimitZero($event)"
                  style="width: 250px"
                ></el-input>
                <span> 元/件</span>
              </el-form-item>
              <el-form-item v-else label="奖品价值:">
                <el-input
                  v-model="physicalForm.discount"
                  style="width: 220px"
                  @keyup.native="limitInput($event)"
                  @blur="physicalForm.discount = inputLimitZero($event)"
                ></el-input>
                元/件
              </el-form-item>
              <el-form-item label="收货信息填写截止时间:">
                <div>
                  <div style="display: flex; align-items: center">
                    <el-date-picker
                      v-model="objectForm.addressFillEndTime"
                      :disabled="objectForm.isFollowActivityEndTime == 0"
                      prefix-icon="no_icon"
                      type="datetime"
                      placeholder="截止时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="margin-right: 4px"
                    ></el-date-picker
                    >前填写(逾期奖品失效处理)
                  </div>
                  <div>
                    <el-checkbox
                      :true-label="0"
                      :false-label="1"
                      v-model="objectForm.isFollowActivityEndTime"
                      @change="objectForm.addressFillEndTime = ''"
                      >跟随活动结束时间(修改活动结束时间时间同步更新)</el-checkbox
                    >
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="修改收货信息限制:">
                <el-radio-group v-model="objectForm.addressFillLimit">
                  <el-radio :label="0">不支持修改地址</el-radio>
                  <el-radio :label="1">支持修改地址</el-radio>
                </el-radio-group>
                <span>（仅在发货前支持修改地址，发货后不可修改地址）</span>
              </el-form-item>
              <el-form-item label="预计发货时间:">
                <div style="display: flex; align-items: center">
                  <el-date-picker
                    v-model="objectForm.predictSendTime"
                    prefix-icon="no_icon"
                    type="datetime"
                    placeholder="截止时间"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="margin-right: 4px"
                  ></el-date-picker
                  >前填写(仅展示作用，无逻辑判断)
                </div>
              </el-form-item>
              <!-- 下单冲榜显示 -->
              <el-form-item label="附加信息收集:" required>
                <el-radio-group v-model="attachInfo.shouldCollectExtraData">
                  <el-radio :label="0">不设置附加信息</el-radio>
                  <el-radio :label="1">设置附加信息</el-radio>
                </el-radio-group>
                <div>
                  <setTopic
                    v-if="attachInfo.shouldCollectExtraData == 1"
                    @collectQuestion="collectQuestion"
                    :questions="attachInfo.questions"
                    :isShowInteraction="false"
                    :isShowAddBtn="false"
                    actionText="编辑"
                  ></setTopic>
                </div>
              </el-form-item>
              <!-- 京东1.77限制 -->
              <el-form-item label="领取奖品限制:" required>
                <el-checkbox-group v-model="objectForm.commitAddressLimit">
                  <el-checkbox :label="0" @change="(checked) => handleCommitAddressLimitChange(0, checked)">不限制</el-checkbox>
                  <el-checkbox :label="1" @change="(checked) => handleCommitAddressLimitChange(1, checked)">同一手机号不可提交地址</el-checkbox>
                  <el-checkbox :label="2" @change="(checked) => handleCommitAddressLimitChange(2, checked)">同一收货人名称不可提交地址</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              

              <!-- 仅A2定制显示 -->
              <template v-if="isATwoPrice">
                <!-- A2奖品介绍 -->
                <el-form-item label="奖品介绍(用户端展示):">
                  <div style="width: 570px; position: relative">
                    <richText
                      v-model="objectForm.introduceToUser"
                      :readOnly="false"
                      :maxLength="500"
                      :height="200"
                    >
                    </richText>
                  </div>
                </el-form-item>
                <el-form-item label="奖品信息(用户端不展示):">
                  <div style="z-index: 99; position: relative">
                    <jd-button
                      v-if="!isShowPrizeInfo"
                      type="blueText"
                      @click="isShowPrizeInfo = true"
                      >展开</jd-button
                    >
                    <jd-button
                      v-else
                      type="blueText"
                      @click="isShowPrizeInfo = false"
                      >收起</jd-button
                    >
                  </div>
                </el-form-item>
                <div v-show="isShowPrizeInfo">
                  <el-form-item label="奖品介绍(用户端不展示):">
                    <el-input
                      type="textarea"
                      maxlength="500"
                      :rows="5"
                      show-word-limit
                      v-model="objectForm.introduce"
                      style="margin-bottom: 5px"
                    ></el-input>
                    <el-upload
                      action="/jd-hd-web/image/upload"
                      :before-upload="beforeUpload"
                      :on-success="handleUpload"
                      :multiple="true"
                      :show-file-list="false"
                    >
                      <jd-button size="small" type="select"
                        >点击上传{{ introducePicUrl.length }}/20</jd-button
                      >
                    </el-upload>
                    <div
                      style="
                        margin-top: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                      "
                    >
                      <el-image
                        v-if="introducePicUrl.length == 0"
                        class="elImg"
                        src=""
                        fit="contain"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-plus"></i>
                        </div>
                      </el-image>
                      <div
                        v-for="(item, index) in introducePicUrl"
                        :key="index"
                        style="position: relative"
                      >
                        <el-image class="elImg" :src="item" fit="contain">
                          <div slot="error" class="image-slot">
                            <i class="el-icon-plus"></i>
                          </div>
                        </el-image>
                        <i
                          class="el-icon-circle-close"
                          style="
                            color: red;
                            position: absolute;
                            top: -2px;
                            right: -2px;
                            font-size: 20px;
                          "
                          @click.stop="delec(index)"
                        >
                        </i>
                        <!-- <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                        
                        class="delectIcom"
                      /> -->
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="奖品厂家(用户端不展示):">
                    <el-input
                      maxlength="50"
                      show-word-limit
                      v-model="objectForm.manufacturer"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="奖品成本(用户端不展示):">
                    <el-input
                      maxlength="50"
                      show-word-limit
                      v-model="objectForm.cost"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                </div>
              </template>
              <!-- <el-form-item>
                <jd-button v-if="(!disabled || isEditList[activeName])&&objectForm.resource != 3" type="blue"
                  :disabled="!objectForm.name || !objectForm.discount" @click="changeJP()">确定</jd-button>

                <jd-button v-else type="blue" :disabled="
                    physicalForm.inventoryType == 0 &&
                    !physicalForm.budgetRemain
                  " @click="changePhysical">确定</jd-button>
              </el-form-item> -->
            </el-form>
          </div>
          <div style="display: flex; justify-content: end">
            <jd-button
              v-if="
                (!disabled || isEditList[activeName]) &&
                objectForm.resource != 3
              "
              type="blue"
              :disabled="!objectForm.name || !objectForm.discount"
              @click="changeJP()"
              >确定</jd-button
            >

            <jd-button
              v-else
              type="blue"
              :disabled="
                physicalForm.inventoryType == 0 && !physicalForm.budgetRemain
              "
              @click="changePhysical"
              >确定</jd-button
            >
          </div>
          </el-tab-pane>
          <!-- <el-tab-pane
            label="实物(实物管理)"
            v-if="
              isShowManage &&
              ((!onlyShowFirst && !isATwoPrice) || isShowGoodsManage)
            "
            name="ten"
          >
            <div style="margin-bottom: 15px">
              <jd-tip>
                <p>
                  奖品库存统一管理，支持批量对多个不同活动的实物中奖记录做发放，更便捷
                </p>
              </jd-tip>
            </div>
            <el-form ref="physicalForm" :model="redForm" label-width="130px">
              <el-form-item label="选择奖品:">
                <el-select
                  v-model="physicalForm.region"
                  placeholder="请选择"
                  @change="handleChangePhysical"
                >
                  <el-option
                    v-for="item in physicalList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <jd-button
                  type="blueText"
                  style="margin: 0px 8px"
                  @click="resetPhysical"
                  >刷新</jd-button
                >
                <jd-button
                  style="margin-right: 8px"
                  type="blue"
                  @click="createPhysical"
                  >创建实物</jd-button
                >
                <p v-if="physicalForm.inventoryType == 1">不限库存</p>
                <p v-else>
                  可用数量
                  <span
                    style="color: #fe4d45"
                    v-if="physicalForm.budgetRemain >= 0"
                    >{{ physicalForm.budgetRemain }}</span
                  >
                  <span v-else>--</span>
                  件
                </p>
              </el-form-item>
              <el-form-item label="奖品价值:">
                <el-input
                  v-model="physicalForm.discount"
                  style="width: 220px"
                ></el-input>
                元/件
              </el-form-item>
              <template v-if="isATwoPrice">
                <el-form-item label="奖品介绍(用户端展示):">
                  <div style="width: 570px; position: relative">
                    <richText
                      v-model="physicalForm.introduceToUser"
                      :readOnly="false"
                      :maxLength="500"
                      :height="200"
                    ></richText>
                  </div>
                </el-form-item>
                <el-form-item label="奖品信息(用户端不展示):">
                  <div style="z-index: 99; position: relative">
                    <jd-button
                      v-if="!physicalForm.isShowPrizeInfo"
                      type="blueText"
                      @click="physicalForm.isShowPrizeInfo = true"
                      >展开</jd-button
                    >
                    <jd-button
                      v-else
                      type="blueText"
                      @click="physicalForm.isShowPrizeInfo = false"
                      >收起</jd-button
                    >
                  </div>
                </el-form-item>
                <div v-show="physicalForm.isShowPrizeInfo">
                  <el-form-item label="奖品介绍(用户端不展示):">
                    <el-input
                      type="textarea"
                      maxlength="500"
                      :rows="5"
                      show-word-limit
                      v-model="physicalForm.introduce"
                      style="margin-bottom: 5px"
                    ></el-input>
                    <el-upload
                      action="/jd-hd-web/image/upload"
                      :before-upload="beforeUpload"
                      :on-success="handleUpload"
                      :multiple="true"
                      :show-file-list="false"
                    >
                      <jd-button size="small" type="select"
                        >点击上传{{
                          physicalForm.introducePicUrl.length
                        }}/20</jd-button
                      >
                    </el-upload>
                    <div
                      style="
                        margin-top: 5px;
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;
                      "
                    >
                      <el-image
                        v-if="physicalForm.introducePicUrl.length == 0"
                        class="elImg"
                        src=""
                        fit="contain"
                      >
                        <div slot="error" class="image-slot">
                          <i class="el-icon-plus"></i>
                        </div>
                      </el-image>
                      <div
                        v-for="(item, index) in physicalForm.introducePicUrl"
                        :key="index"
                        style="position: relative"
                      >
                        <el-image class="elImg" :src="item" fit="contain">
                          <div slot="error" class="image-slot">
                            <i class="el-icon-plus"></i>
                          </div>
                        </el-image>
                        <i
                          class="el-icon-circle-close"
                          style="
                            color: red;
                            position: absolute;
                            top: -2px;
                            right: -2px;
                            font-size: 20px;
                          "
                          @click.stop="
                            physicalForm.introducePicUrl.splice(index, 1)
                          "
                        >
                        </i>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="奖品厂家(用户端不展示):">
                    <el-input
                      maxlength="50"
                      show-word-limit
                      v-model="physicalForm.manufacturer"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="奖品成本(用户端不展示):">
                    <el-input
                      maxlength="50"
                      show-word-limit
                      v-model="physicalForm.cost"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                </div>
              </template>
              <el-form-item style="margin-left: -130px">
                <jd-button
                  type="blue"
                  :styleTextObj="{width: '180px'}"
                  :disabled="
                    physicalForm.inventoryType == 0 &&
                    !physicalForm.budgetRemain
                  "
                  @click="changePhysical"
                  >选择实物</jd-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane> -->
          <el-tab-pane
            label="店铺积分"
            v-if="!onlyShowFirst && !isATwoPrice && !hideShopPoints"
            name="four"
          >
            <template v-if="!isPointsEnabled">
              <div style="height: 300px">
                暂未开通此权限，请先开通后进行选择
                <span @click="handlelink" class="pointer" style="color: #fe4d45"
                  >去开通>></span
                >
              </div>
            </template>
            <template v-else>
              <div style="margin-bottom: 15px">
                <jd-tip>
                  <div>
                    店铺积分：发放积分需要加入京东会员体系，并开通积分功能
                  </div>
                </jd-tip>
              </div>
              <el-form
                ref="integralForm"
                :model="integralForm"
                label-width="103px"
              >
                <el-form-item label="奖品图:">
                  <div style="display: flex; align-items: center">
                    <el-upload
                      :show-file-list="false"
                      action="#"
                      :on-change="handleChange"
                    >
                      <div class="uploadButton">
                        <img
                          v-if="fourLogo"
                          :src="fourLogo"
                          style="width: 100%; height: 100%"
                        />
                        <i v-else class="el-icon-plus"></i>
                      </div>
                    </el-upload>
                    <div
                      style="color: #999999; font-size: 12px; margin-left: 12px"
                    >
                      <div>建议尺寸：200*200px</div>
                      <div>图片大小：300k以内</div>
                      <div>格式：jpg、png</div>
                    </div>
                    <jd-button
                      type="blueText"
                      style="margin-left: 12px"
                      @click="
                        fourLogo =
                          'https://cdn-image.yucrm.cn/e5250807717b404f8296bee167c668d1.png'
                      "
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="单份积分数量:">
                  <el-input
                    v-model.number="integralForm.discount"
                    @input="integralForm.discount = checkputn($event)"
                    style="width: 220px"
                  ></el-input>
                </el-form-item>
                <!-- <el-form-item style="margin-left: -103px">
                  <jd-button type="blue" :styleTextObj="{width: '180px'}" @click="
                      storePoint();
                      dialogVisibleFrom = false;
                    " :disabled="!integralForm.discount">选择店铺积分奖品</jd-button>
                </el-form-item> -->
              </el-form>
              <div style="display: flex; justify-content: end">
                <jd-button
                  type="blue"
                  @click="
                    storePoint();
                    dialogVisibleFrom = false;
                  "
                  :disabled="!integralForm.discount"
                  >确定</jd-button
                >
              </div>
            </template>
          </el-tab-pane>
          <el-tab-pane
            label="京东E卡"
            v-if="isShowEK && !onlyShowFirst"
            name="fird"
          >
            <div style="margin-bottom: 15px">
              <jd-tip>
                <div>
                  根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
                </div>
              </jd-tip>
            </div>
            <el-form
              ref="ekForm"
              :model="ekForm"
              :label-width="!isATwoPrice ? '125px' : '155px'"
            >
              <el-form-item label="奖品图:">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="firdLogo"
                        :src="firdLogo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="
                      firdLogo =
                        'https://cdn-image.yucrm.cn/aab7875b7cb34e15a0acca8eac7f0045.png'
                    "
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选择京东E卡计划:">
                <el-select
                  v-model="ekForm.region"
                  placeholder="请选择"
                  @change="change"
                  :disabled="isEditList[activeName]"
                >
                  <el-option
                    v-for="(item, index) in eKselectList"
                    :key="index"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <jd-button
                  type="blueText"
                  @click="acquireAssets"
                  style="margin: 0px 8px"
                  :disabled="isEditList[activeName]"
                  >刷新</jd-button
                >
                <jd-button
                  style="margin-right: 8px"
                  type="blue"
                  @click="jumpEkCz"
                  :disabled="isEditList[activeName]"
                  >创建京东E卡官方充值</jd-button
                >
                <jd-button
                  type="blue"
                  @click="jumpEk"
                  :disabled="isEditList[activeName]"
                  >创建京东E卡发放计划</jd-button
                >
                <p>
                  剩余
                  <span style="color: #fe4d45">{{ ekForm.budgetRemain }}</span>
                  张
                </p>
              </el-form-item>
              <el-form-item label="单份奖品:">
                <el-input
                  v-model="ekForm.num"
                  style="width: 220px"
                  :disabled="true"
                ></el-input>
                <span> 张（京东E卡单份奖品每人每次只能奖励1张）</span>
              </el-form-item>
              <el-form-item label="奖品介绍(用户端展示):" v-if="isATwoPrice">
                <div style="width: 570px; position: relative">
                  <richText
                    v-model="ekForm.introduceToUser"
                    :readOnly="false"
                    :maxLength="500"
                    :height="200"
                  >
                  </richText>
                </div>
              </el-form-item>
              <!-- <el-form-item style="margin-left: -125px">
                <jd-button v-if="!disabled || isEditList[activeName]" type="blue" :styleTextObj="{width: '180px'}"
                  :disabled="!ekForm.num" @click="
                    jingDonData();
                    jingDonEka(5);
                  ">选择京东E卡奖品</jd-button>
              </el-form-item> -->
            </el-form>
            <div style="display: flex; justify-content: end">
              <jd-button
                v-if="!disabled || isEditList[activeName]"
                type="blue"
                :disabled="!ekForm.num"
                @click="
                  jingDonData();
                  jingDonEka(5);
                "
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="爱奇艺会员"
            v-if="isShowIQY && !onlyShowFirst && !isATwoPrice"
            name="six"
          >
            <div style="margin-bottom: 15px">
              <jd-tip>
                <div>
                  根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
                </div>
              </jd-tip>
            </div>
            <el-form ref="aqyForm" :model="aqyForm" label-width="144px">
              <el-form-item label="奖品图:">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="sixLogo"
                        :src="sixLogo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="
                      sixLogo =
                        'https://cdn-image.yucrm.cn/6760b46a47da4fc1ac557c7ca8a7c0d9.png'
                    "
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选择爱奇艺会员计划:">
                <el-select
                  v-model="aqyForm.region"
                  placeholder="请选择"
                  @change="change"
                >
                  <el-option
                    v-for="(item, index) in eKselectList"
                    :key="index"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <jd-button
                  type="blueText"
                  style="margin: 0px 8px"
                  @click="acquireAssets"
                  >刷新</jd-button
                >
                <jd-button
                  style="margin-right: 8px"
                  type="blue"
                  @click="jumpaqyCz"
                  >创建爱奇艺官方充值</jd-button
                >
                <jd-button type="blue" @click="jumpaqy"
                  >创建爱奇艺发放计划</jd-button
                >
                <p>
                  剩余
                  <span style="color: #fe4d45">{{ aqyForm.budgetRemain }}</span>
                  张
                </p>
              </el-form-item>
              <el-form-item label="单份奖品:">
                <el-input
                  v-model="aqyForm.num"
                  style="width: 220px"
                  :disabled="true"
                ></el-input>
                <span> 张（爱奇艺会员单份奖品每人每次只能奖励1张）</span>
              </el-form-item>
              <!-- <el-form-item style="margin-left: -144px">
                <jd-button type="blue" :styleTextObj="{width: '180px'}" :disabled="!aqyForm.num" @click="
                    jingDonData();
                    jingDonEka(6);
                  ">选择爱奇艺会员奖品</jd-button>
              </el-form-item> -->
            </el-form>
            <div style="display: flex; justify-content: end">
              <jd-button
                type="blue"
                :disabled="!aqyForm.num"
                @click="
                  jingDonData();
                  jingDonEka(6);
                "
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="京东PLUS会员"
            v-if="isShowPLUS && !onlyShowFirst && !isATwoPrice"
            name="sev"
          >
            <div style="margin-bottom: 15px">
              <jd-tip>
                <div>
                  根据京东规则，新创建计划开始时间需要在当前时间5分钟后，如果您是刚刚创建计划，请稍后点击刷新
                </div>
              </jd-tip>
            </div>
            <el-form ref="plusForm" :model="plusForm" label-width="165px">
              <el-form-item label="奖品图:">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="sevLogo"
                        :src="sevLogo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="
                      sevLogo =
                        'https://cdn-image.yucrm.cn/9133d3b3a0da434f8b0512cc1b3a684a.png'
                    "
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选择京东PLUS会员计划:">
                <el-select
                  v-model="plusForm.region"
                  placeholder="请选择"
                  @change="change"
                >
                  <el-option
                    v-for="(item, index) in eKselectList"
                    :key="index"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <jd-button
                  type="blueText"
                  style="margin: 0px 8px"
                  @click="acquireAssets"
                  >刷新</jd-button
                >
                <jd-button
                  style="margin-right: 8px"
                  type="blue"
                  @click="jumpPlusCz"
                  >创建PLUS会员充值</jd-button
                >
                <jd-button type="blue" @click="jumpPlus"
                  >创建PLUS会员发放</jd-button
                >
                <p>
                  剩余
                  <span style="color: #fe4d45">{{
                    plusForm.budgetRemain
                  }}</span>
                  张
                </p>
              </el-form-item>
              <el-form-item label="单份奖品:">
                <el-input
                  v-model="plusForm.num"
                  style="width: 220px"
                  :disabled="true"
                ></el-input>
                <span> 张，（京东PLUS会员单份奖品每人每次只能奖励1张）</span>
              </el-form-item>
              <!-- <el-form-item style="margin-left: -165px">
                <jd-button type="blue" :styleTextObj="{width: '180px'}" :disabled="!plusForm.num" @click="
                    jingDonData();
                    jingDonEka(7);
                  ">选择京东PLUS奖品</jd-button>
              </el-form-item> -->
            </el-form>
            <div style="width: 100%; display: flex; justify-content: end">
              <jd-button
                type="blue"
                :disabled="!plusForm.num"
                @click="
                  jingDonData();
                  jingDonEka(7);
                "
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="现金红包"
            v-if="isShowHongBao && !onlyShowFirst && !isATwoPrice"
            name="eig"
          >
            <div style="margin-bottom: 15px">
              <jd-tip>
                <p>
                  根据京东规则，红包计划创建后10分钟才能生效，为避免等待时间，请提前创建活动！
                </p>
                <p>默认红包计划最短不少于3天，最长不超过30天，详见红包权益；</p>
              </jd-tip>
            </div>
            <el-form ref="ekForm" :model="redForm" label-width="130px">
              <el-form-item label="奖品图:">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="eigLogo"
                        :src="eigLogo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="
                      eigLogo =
                        'https://cdn-image.yucrm.cn/ab7f7d3e28594787b34970f084cb8337.png'
                    "
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选择现金红包计划:">
                <!-- <el-select v-model="redForm.region" placeholder="请选择">
                <el-option label="计划一" value="shanghai"></el-option>
                <el-option label="计划二" value="beijing"></el-option>
                <el-option label="计划三" value="beijing"></el-option>
              </el-select> -->
                <el-select
                  v-model="redForm.region"
                  placeholder="请选择"
                  @change="change1"
                >
                  <el-option
                    v-for="(item, index) in redSelectList"
                    :key="item.id"
                    :label="item.label"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <jd-button
                  type="blueText"
                  style="margin: 0px 8px"
                  @click="redBag"
                  >刷新</jd-button
                >
                <jd-button
                  style="margin-right: 8px"
                  type="blue"
                  @click="jumpRedCz"
                  >创建现金红包充值</jd-button
                >
                <jd-button type="blue" @click="jumpRed"
                  >创建现金红包发放</jd-button
                >
                <p>
                  剩余
                  <span style="color: #fe4d45">{{ redForm.budgetRemain }}</span>
                  份
                </p>
              </el-form-item>
              <el-form-item label="单份奖品:">
                <el-input
                  v-model="redForm.num"
                  style="width: 220px"
                  :disabled="true"
                ></el-input>
                元
              </el-form-item>
              <!-- <el-form-item style="margin-left: -130px">
                <jd-button type="blue" :styleTextObj="{width: '180px'}" :disabled="!redForm.num" @click="
                    redData();
                    jingDonEka(8);
                  ">选择红包奖品</jd-button>
              </el-form-item> -->
            </el-form>
            <div style="width: 100%; display: flex; justify-content: end">
              <jd-button
                type="blue"
                :disabled="!redForm.num"
                @click="
                  redData();
                  jingDonEka(8);
                "
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="礼品卡"
            name="nine"
            v-if="isShowGiftCard && !onlyShowFirst && !isATwoPrice"
          >
            <gift-card
              v-loading="loading"
              :giftCardList="giftCardList"
              :giftData="giftCardForm"
              @refreshGiftCard="refreshGiftCard"
              @handleGetGiftCard="handleGetGiftCard"
            >
              <template #formSlot>
                <el-form-item label="奖品图:">
                  <div style="display: flex; align-items: center">
                    <el-upload
                      :show-file-list="false"
                      action="#"
                      :on-change="handleChange"
                    >
                      <div class="uploadButton">
                        <img
                          v-if="nineLogo"
                          :src="nineLogo"
                          style="width: 100%; height: 100%"
                        />
                        <i v-else class="el-icon-plus"></i>
                      </div>
                    </el-upload>
                    <div
                      style="color: #999999; font-size: 12px; margin-left: 12px"
                    >
                      <div>建议尺寸：200*200px</div>
                      <div>图片大小：300k以内</div>
                      <div>格式：jpg、png</div>
                    </div>
                    <jd-button
                      type="blueText"
                      style="margin-left: 12px"
                      @click="
                        nineLogo =
                          'https://cdn-image.yucrm.cn/01ffdba6acaa43c48423cda39e99cb5e.png'
                      "
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
              </template>
            </gift-card>
          </el-tab-pane>
          <el-tab-pane
            label="令牌"
            name="twelve"
            v-if="showNewToken && !onlyShowFirst && !isATwoPrice"
          >
            <jd-tip class="mb15">
              同一令牌每个用户仅限领取一次，如该奖品已投放至其他活动也会出现领取冲突
            </jd-tip>
            <el-form
              :model="tokenForm"
              ref="twelveFormRef"
              :rules="tokenRules"
              label-width="130px"
            >
              <el-form-item label="奖品图:" prop="logo">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="tokenForm.logo"
                        :src="tokenForm.logo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="tokenForm.logo = twelveLogo"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选择令牌:" prop="couponId">
                <jd-button
                  type="blue"
                  @click="selectToken"
                  >选择</jd-button
                >
                <div class="mt12">
                  <jd-table
                    :tableData="tokenData"
                    :tableInfo="tokenTableInfo"
                    :pageInfo="{ noShow: true }"
                    :loading="tokenLoading"
                    v-show="tokenForm.couponId"
                  >
                    <template v-slot:timeSlot="scope">
                      <div>起：{{ scope.row.startTime }}</div>
                      <div>止：{{ scope.row.endTime }}</div>
                    </template>

                    <template v-slot:actionSlot="scope">
                      <jd-button
                        type="blueText"
                        @click="removeToken(scope.$index)"
                        >移除</jd-button
                      >
                    </template>
                  </jd-table>
                </div>
              </el-form-item>
            </el-form>
            <div style="width: 100%; text-align: right">
              <jd-button type="blue" :disabled="!tokenForm.couponId||!tokenForm.logo" @click="submitTokenForm('twelveFormRef')"
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="专享价"
            name="eleven"
            v-if="showExclusive&&!venderType && !onlyShowFirst && !isATwoPrice"
          >
            <jd-tip class="mb15">
              同一专享价每个用户仅限领取一次，如该奖品已投放至其他活动也会出现领取冲突
            </jd-tip>
            <el-form
              :model="exclusivePriceForm"
              ref="elevenFormRef"
              :rules="exclusiveRules"
              label-width="130px"
            >
              <el-form-item label="奖品图:" prop="logo">
                <div style="display: flex; align-items: center">
                  <el-upload
                    :show-file-list="false"
                    action="#"
                    :on-change="handleChange"
                  >
                    <div class="uploadButton">
                      <img
                        v-if="exclusivePriceForm.logo"
                        :src="exclusivePriceForm.logo"
                        style="width: 100%; height: 100%"
                      />
                      <i v-else class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                  <div
                    style="color: #999999; font-size: 12px; margin-left: 12px"
                  >
                    <div>建议尺寸：200*200px</div>
                    <div>图片大小：300k以内</div>
                    <div>格式：jpg、png</div>
                  </div>
                  <jd-button
                    type="blueText"
                    style="margin-left: 12px"
                    @click="exclusivePriceForm.logo = elevenLogo"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选择专享价活动:" prop="couponId">
                <jd-button type="blue" @click="selectExclusivePrice"
                  >选择</jd-button
                >
                <div class="mt12">
                  <jd-table
                    :tableData="actData"
                    :tableInfo="actTableInfo"
                    :pageInfo="{ noShow: true }"
                    :loading="exclusiveLoading"
                    v-show="exclusivePriceForm.couponId"
                  >
                    <template v-slot:priceSlot="scope">
                      <div>
                        京东价：{{
                          scope.row.skuNum > 1
                            ? `${scope.row.minJdPrice}~${scope.row.maxJdPrice}`
                            : scope.row.minJdPrice
                        }}
                      </div>
                      <div>
                        折扣价：{{
                          scope.row.skuNum > 1
                            ? `${scope.row.minPayPrice}~${scope.row.maxPayPrice}`
                            : scope.row.minPayPrice
                        }}
                      </div>
                    </template>

                    <template v-slot:actionSlot="scope">
                      <jd-button
                        type="blueText"
                        @click="removeAct(scope.$index)"
                        >移除</jd-button
                      >
                    </template>
                  </jd-table>
                </div>
              </el-form-item>
            </el-form>
            <div style="width: 100%; text-align: right">
              <jd-button
                type="blue"
                :disabled="!exclusivePriceForm.couponId||!exclusivePriceForm.logo"
                @click="submitExclusivePriceForm('elevenFormRef')"
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="实物奖品（随单发）"
            name="thirteen"
            class="with-order-tab"
            v-if="isShowWithOrderShot"
          >
          <!-- 实现实物奖品（随单发） UI-->
            <div class="order-box">
              <el-form
                  ref="withOrderFormRef"
                  :model="withOrderForm"
                  :label-width="!isATwoPrice ? '158px' : '168px'"
                >
                  <el-form-item label="奖品来源:">
                    <el-radio-group
                      v-model="withOrderForm.resource"
                      @change="cleanImg"
                    >
                      <el-radio label="2">直接填写</el-radio>
                      <el-radio label="1">从店铺中选择</el-radio>
                      <el-radio label="3">从【实物管理】栏目选择</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item v-show="withOrderForm.resource == 2">
                    <el-upload
                      ref="upload"
                      action="#"
                      list-type="picture-card"
                      :on-change="handleChange"
                      :on-remove="handleRemove"
                      :http-request="httpRequest"
                      :file-list="fileList"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <span style="color: #fe4d45; font-size: 12px"
                      >建议尺寸：200*200像素，图片大小不能超过300K，类型：JPG、PNG</span
                    >
                  </el-form-item>
                  <el-form-item v-if="withOrderForm.resource == 1">
                    <div v-if="withOrderForm.logo && withOrderForm.resource == 1">
                      <img
                        :src="withOrderForm.logo"
                        alt=""
                        style="width: 150px; height: 150px"
                      />
                    </div>
                    <jd-button
                      @click="
                        dialogFormVisible = true;
                        getShopList();
                      "
                      style="width: 110px; text-align: center"
                      >选择店铺商品</jd-button
                    >
                  </el-form-item>
                  <template v-if="withOrderForm.resource == 3">
                    <el-form-item label="选择奖品:">
                      <el-select
                        v-model="physicalForm.region"
                        placeholder="请选择"
                        @change="handleChangePhysical"
                      >
                        <el-option
                          v-for="item in physicalList"
                          :key="item.id"
                          :label="item.label"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                      <jd-button
                        type="blueText"
                        style="margin: 0px 8px"
                        @click="resetPhysical"
                        >刷新</jd-button
                      >
                      <jd-button
                        style="margin-right: 8px"
                        type="blue"
                        @click="createPhysical"
                        >创建实物</jd-button
                      >
                      <p v-if="physicalForm.inventoryType == 1">不限库存</p>
                      <p v-else>
                        可用数量
                        <span
                          style="color: #fe4d45"
                          v-if="physicalForm.budgetRemain >= 0"
                          >{{ physicalForm.budgetRemain }}</span
                        >
                        <span v-else>--</span>
                        件
                      </p>
                    </el-form-item>
                    <el-form-item v-if="physicalForm.logo" label="">
                      <div>
                        <img
                          style="
                            width: 148px;
                            height: 148px;
                            border-radius: 6px;
                            overflow: hidden;
                          "
                          :src="physicalForm.logo"
                        />
                      </div>
                    </el-form-item>
                  </template>
                  <el-form-item v-if="withOrderForm.resource != 3" label="奖品名称:" required>
                    <el-input
                      v-model="withOrderForm.name"
                      :maxlength="isATwoPrice ? '20' : '12'"
                      show-word-limit
                      placeholder="请输入"
                      :style="{ width: '250px' }"
                    ></el-input>
                  </el-form-item>
                  <el-form-item v-if="withOrderForm.resource != 3" label="奖品价值:" required>
                    <el-input
                      v-model="withOrderForm.discount"
                      @keyup.native="limitInput($event)"
                      @blur="withOrderForm.discount = inputLimitZero($event)"
                      placeholder="请输入"
                      style="width: 250px"
                    ></el-input>
                    <span> 元/件</span>
                  </el-form-item>
                  <el-form-item v-else label="奖品价值:" required>
                    <el-input
                      v-model="physicalForm.discount"
                      style="width: 220px"
                      @keyup.native="limitInput($event)"
                      @blur="physicalForm.discount = inputLimitZero($event)"
                    ></el-input>
                    元/件
                  </el-form-item>
                  <el-form-item label="备注内容:" required>
                    <el-input
                      type="textarea"
                      v-model="withOrderForm.pointActivityPrizeRemark.content"
                      style="width: 250px"
                      placeholder="请输入同步备注文案内容"
                      :maxlength="500"
                      :rows="4"
                      show-word-limit
                    ></el-input>
                    <jd-tip class="mt16">注意请勿在订单上手动修改该备注，否则奖品失效后取消备注时无法识别是否存在备注，导致无法删除备注</jd-tip>
                  </el-form-item>
                  <el-form-item label="备注方式:" required>
                    <el-radio-group
                      v-model="withOrderForm.pointActivityPrizeRemark.remarkActionType"
                      @change="handleChangeRemarkType"
                    >
                      <el-radio :label="2">系统自动备注已有订单</el-radio>
                      <el-radio :label="0">系统自动备注下一笔订单</el-radio>
                      <el-radio :label="1" v-if="isShowManual">用户手动选择已有订单</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="备注订单条件:" required>
                    <div class="mt16">
                      <el-form-item label="下单时间:" required label-width="auto">
                        <div class="my_select_time" v-if="withOrderForm.pointActivityPrizeRemark.remarkActionType != 0">
                          <el-date-picker prefix-icon="no_icon" v-model="withOrderForm.pointActivityPrizeRemark.startOrderTime" type="datetime" placeholder="开始日期"
                              size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              style="width: 185px; font-size: 12px" class="time1"
                              default-time="00:00:00"
                              :picker-options="pickerOptionsStart"
                              :clearable="false" isabled="disabled">
                          </el-date-picker>
                          <div class="time_to_text">至</div>
                          <el-date-picker prefix-icon="no_icon" v-model="withOrderForm.pointActivityPrizeRemark.endOrderTime" type="datetime" placeholder="结束日期"
                              size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              style="width: 200px; font-size: 12px" class="time2" @change="activityTimeChange"
                              :picker-options="pickerOptionsEnd"
                              default-time="00:00:00"
                              :clearable="false" >
                          </el-date-picker>
                          <i class="el-icon-circle-close date_icon1" v-if="!disabled" @click="clearTime()"></i>
                          <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                              class="date_icon2" />
                        </div>
                        <div v-else>
                          获得奖品后
                          <el-input class="mlr8" v-model="withOrderForm.pointActivityPrizeRemark.tradeLimitTime" style="width: 100px" placeholder="请输入" @input="withOrderForm.pointActivityPrizeRemark.tradeLimitTime = getNumberData(1, $event, 0, 1,999999)"></el-input>
                          <el-select v-model="withOrderForm.pointActivityPrizeRemark.tradeLimitTimeUnit" style="width: 100px" placeholder="请选择">
                            <el-option label="天" :value="2"></el-option>
                            <el-option label="小时" :value="1"></el-option>
                            <el-option label="分钟" :value="0"></el-option>
                          </el-select>
                          <span class="ml8">下单并付款完成</span>
                        </div>
                      </el-form-item>
                      <el-form-item label="订单金额:" required label-width="auto">
                        <span class="mr8">大于等于</span>
                        <el-input
                          v-model="withOrderForm.pointActivityPrizeRemark.receivePayment"
                          @input="withOrderForm.pointActivityPrizeRemark.receivePayment = getNumberData(1, $event, 1, 0,999999)"
                          style="width: 250px"
                          placeholder="请输入"
                          ></el-input>
                          <span class="ml8">元</span>
                      </el-form-item>
                      <el-form-item label="商品要求:" required label-width="auto">
                        <el-radio-group
                          v-model="withOrderForm.pointActivityPrizeRemark.skuMatchType"
                          @change="handleChangeProductType"
                        >
                          <el-radio :label="0">全部</el-radio>
                          <el-radio :label="1">指定商品</el-radio>
                          <el-radio :label="2">排除商品</el-radio>
                        </el-radio-group>
                        <jd-button v-loading="goodsLoading" v-if="withOrderForm.pointActivityPrizeRemark.skuMatchType != 0" class="ml8" @click="selectExcludeGoods">已选{{ excludeOrSpecifyList.length }}个</jd-button>
                      </el-form-item>
                      <div class="req-tips" v-html="orderTips">
                      </div>
                    </div>
                  </el-form-item>
                  <!-- <el-form-item label="奖品失效备注:" required>
                    <el-input
                      type="textarea"
                      v-model="withOrderForm.pointActivityPrizeRemark.loseEfficacyRemark"
                      style="width: 250px"
                      placeholder="请输入奖品失效文案内容，例【订单已取消】"
                      :maxlength="500"
                      :rows="4"
                      show-word-limit
                    ></el-input>
                    <div class="red-tips">
                      用户因中奖订单退款导致奖品失效，新增一个备注说明：即表示用户活动期间因为退款后不符合中奖条件等原因导致奖品失效后，随单发备注同步不删除，并且新增一个新的备注以补充说明
                    </div>
                  </el-form-item> -->
              </el-form>
            </div>
            <div class="footer-btn">
              <jd-button
                v-if="
                  (!disabled || isEditList[activeName]) &&
                  withOrderForm.resource != 3
                "
                type="blue"
                :disabled="!withOrderForm.name || !withOrderForm.discount"
                @click="changeWithOrder()"
                >确定</jd-button
              >
              <jd-button
                v-else
                type="blue"
                :disabled="
                  physicalForm.inventoryType == 0 && !physicalForm.budgetRemain
                "
                @click="changePhysicalWithOrder()"
                >确定</jd-button
              >
            </div>
          </el-tab-pane>
        </el-tabs>
        <div
          v-if="disabled"
          :style="{ height: isEditList[activeName] ? '40px' : '100%' }"
          class="select-disabled"
        ></div>
      </div>
    </jd-dialog>

    <!-- 选择商品弹窗 -->
    <jd-dialog
      title="选择商品"
      append-to-body
      :visible.sync="dialogFormVisible"
      width="890px"
      :isShowSure="false"
      :isShowCancel="false"
    >
      <!-- <input-form
        style="margin: 20px 0"
        :inputData="commodityList"
        :immediately="true"
        @toParentVal="searchContent"
      ></input-form> -->
      <jd-form
        :form-info="formInfo"
        @search="searchContent"
        :immediately="true"
      />
      <jd-table
        style="margin-top: 16px"
        :tableData="tableShopData"
        :pageInfo="{
          pageNum: formShopList.current,
          pageSize: formShopList.size,
          total: totalListThr,
        }"
        :maxTotal="5"
        :pageSizes="[5, 10, 30, 50, 100]"
        @handlePage="handlePage"
        stripe
      >
        <el-table-column width="100">
          <template slot-scope="scope">
            <img
              :src="scope.row.logo"
              class="avar"
              alt="商品图片"
              style="height: 60px; width: 60px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="skuName" label="商品名称" width="300">
          <template slot-scope="scope">
            <a :href="scope.row.itemUrl" target="_blank"
              >{{ scope.row.skuName }}<br />
              ¥{{ scope.row.jdPrice }}</a
            >
            <!-- <span>{{ scope.row.skuName }}</span
            ><br />
            <span>¥{{ scope.row.jdPrice }}</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="SKU ID" width="200">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <jd-button type="blueText" v-loading="sureLoading" @click="chooseShop(scope.row)"
              >选择</jd-button
            >
          </template>
        </el-table-column>
      </jd-table>
      <!-- <el-pagination
        style="margin: 40px 80px 0 0; text-align: right"
        background
        @size-change="handleSizeChangeThr"
        @current-change="handleCurrentChangeThr"
        :current-page="formShopList.current"
        :page-sizes="[5, 10, 30, 50, 100]"
        :page-size="formShopList.size"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="totalListThr"
      ></el-pagination> -->
    </jd-dialog>
    <add-coupon
      :isSuperFission="true"
      :isShow="addCouponIsShow"
      @close="addCouponIsShow = false"
      @funcMes="addStatus"
    ></add-coupon>
    <add-coupon2
      :isShow="addCouponIsShow2"
      @close="addCouponIsShow2 = false"
      @funcMes="addStatus2"
    ></add-coupon2>
    <selectSpecialDialog
      v-if="isShowExclusive"
      v-model="isShowExclusive"
      :exclusivePriceId="exclusivePriceForm.couponId"
      @confirm="confirmExclusive"
    ></selectSpecialDialog>
    <!-- 选择令牌弹窗 -->
    <selectTokenDialog
      v-if="isShowToken"
      v-model="isShowToken"
      :tokenId="tokenForm.couponId"
      @confirm="confirmToken"
    ></selectTokenDialog>
    <!-- 选择排除商品弹窗 -->
    <selectGoods
      v-if="isShowExclude"
      :isShow="isShowExclude"
      @close="getSpecifyOrExcludeGoods"
      :selectGoods="excludeOrSpecifyList"
      :moduleType="true"
      :skuSearch="true"
    ></selectGoods>
  </div>
</template>

<script>
import inputForm from "@/components/jhk/inputForm";
import SelectGoods from "@/components/selectGoodsMonitor2.vue";
import {
  couponList,
  jingdouList,
  allAccountList,
  redPacketList,
  judgingActivation,
  isauth,
} from "@/api/jhk/integralCenter/prizeCenter.js";
import {
  querySellerCouponWriteList,
  querySellerCouponExternalList,
  createSellerCouponWrite,
} from "@/api/jhk/integralCenter/couponWriteController";
import {
  getTaobaoItemListSku,
  getSellercats,
} from "@/api/jhk/analysis/ware-controller.js";
import { uploadpic } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getSupplierAccountList } from "@/api/jhk/integralCenter/prizeCenter.js";
import addCoupon from "./add_coupon1.vue";
import addCoupon2 from "./add_coupon2.vue";
import giftCard from "./components/giftCard/index.vue";
import { getGoodsPage } from "@/api/jhk/integralCenter/physical.js";
import { getGiftCardPage } from "@/api/jhk/integralCenter/prizeCenter.js";
import richText from "@/components/richText.vue";
import selectSpecialDialog from "./components/selectSpecialDialog.vue";
import selectTokenDialog from "@/views/interactiveMarketing/promo/components/selectTokenDialog.vue";
import setTopic from "./components/setTopic/index.vue";
import {
  promoTokenDetail, //令牌详情接口
} from "@/api/integralCenter/tokenSummary.js";
import { getExclusivePricePlanPage } from "@/api/jhk/integralCenter/prizeCenter.js"; //专享价列表接口
import { checkProduct } from "@/api/jhk/activity.js";
const actionType = ["", "jingdouPut"];
export default {
  name: "selectProduct",
  components: {
    inputForm,
    SelectGoods,
    addCoupon,
    addCoupon2,
    giftCard,
    richText,
    selectSpecialDialog,
    selectTokenDialog,
    setTopic
  },
  props: {
    islimiCouponUrl: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      default: "选择奖品",
    },
    onlyShowFirst: {
      type: Boolean,
      default: false,
    },
    //隐藏优惠券
    isShowFirst: {
      type: Boolean,
      default: false,
    },
    // 隐藏内部券
    Sans: {
      type: Boolean,
      default: false,
    },
    // 隐藏外部券
    outsideShow: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    // 爱奇艺、E卡、红包回显
    actId: null,
    tipShow: {
      type: Boolean,
      default: false,
    },
    putPrize: {
      type: Object,
    },
    // 回显的数据
    echoDate: {
      type: Object,
      default: () => {
        return {};
      },
    },
    //typeDefault可不传 默认京券 免费领取 不公开 （店铺礼包、每日抢、评价有礼、裂变神券、天降红包雨幸运抽奖 ，互动中心-会员权益-新人优惠券、会员券）
    typeDefault: {
      type: Object,
      default() {
        return {
          grantType: 3, // 发放类型  传对应的id值
          display: 1, // 是否公开  传对应的id值
          type: 0, // 不禁用  传对应的id值
          noDisabled: [3], // 不禁用  传对应的id值  可不传（全部可选）
        };
      },
    },
    // num != 2 JingdouCount中的prizeCount必传 计算填的京豆总数是否大于京豆总数
    JingdouCount: {
      type: Object,
      default() {
        return {
          prizeCount: 0,
        };
      },
    },
    // 奖品类型 是否有梯度奖品  1否 2是
    num: {
      default: 2,
    },
    jdArr: {
      type: Array,
      default() {
        return [];
      },
    },
    // a2品牌定制奖品选择
    isATwoPrice: {
      type: Boolean,
      default: false,
    },
    // 不能操作
    disabled: {
      type: Boolean,
      default: false,
    },
    // 是否展示实物管理
    isShowGoodsManage: {
      type: Boolean,
      default: false,
    },
    // 某个tab-pane是否允许修改
    isEditList: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 隐藏店铺积分
    hideShopPoints: {
      type: Boolean,
      default: false,
    },
    // 隐藏优惠券
    isShowCoupon: {
      type: Boolean,
      default: true,
    },
    // 隐藏京豆
    isShowJingdou: {
      type: Boolean,
      default: true,
    },
    // 隐藏实物
    isShowThing: {
      type: Boolean,
      default: true,
    },
    // 隐藏实物管理
    isShowManage: {
      type: Boolean,
      default: true,
    },
    // 隐藏E卡
    isShowEK: {
      type: Boolean,
      default: true,
    },
    // 隐藏爱奇艺
    isShowIQY: {
      type: Boolean,
      default: true,
    },
    // 隐藏PLUS
    isShowPLUS: {
      type: Boolean,
      default: true,
    },
    // 隐藏红包
    isShowHongBao: {
      type: Boolean,
      default: true,
    },
    // 隐藏礼品卡
    isShowGiftCard: {
      type: Boolean,
      default: true,
    },
    defaultSelect: {
      type: String,
      default: "",
    },
    // 隐藏百度云盘礼品卡
    notBaidu: {
      type: Boolean,
      default: false,
    },
    // 隐藏专享价
    showExclusive: {
      type: Boolean,
      default: true,
    },
    // 是否展示令牌
    showNewToken: {
      type: Boolean,
      default: true,
    },
    // 专享价是否绑定指定商品
    isBindGoods: {
      type: Boolean,
      default: false,
    },
    // 专享价绑定指定商品的skuId
    specifyId: {
      type: String,
      default: '',
    },
    // 已选专享价/令牌id
    hasSelectIds: {
      type: Array,
      default() {
        return [];
      },
    },
    // 活动类型
    actType: {
      type: Number,
      default: 0,
    },
    // 活动结束时间
    actEndTime: {
      type: String,
      default: '',
    },
  },
  computed: {
    formInfo() {
      let arr = [
        {
          label: "商品类目：",
          placeholder: "请选择",
          prop: "categoryId",
          type: "cascader",
          options: this.cascaderList,
          props: { multiple: true },
        },
        {
          label: "SKU ID：",
          prop: "skuId",
          type: "Input",
          placeholder: "请输入SKU ID",
        },
        {
          label: "商品名称：",
          prop: "skuName",
          type: "Input",
          placeholder: "请输入商品名称",
        },
        {
          label: "商品状态：",
          prop: "skuStatus",
          type: "Select",
          value: 1,
          options: [
            { label: "全部", value: null },
            { label: "上架", value: 1 },
            { label: "下架", value: 2 },
          ],
        },
      ];
      return arr;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    // 是否显示随单发栏目
    isShowWithOrderShot() {
      const activityTypes = [77,76,71,68,66,64,62,52,46,48,47,53,45,44,8,16,19,17,18,6,5,4,1,34,20,24,22,3,39,36,28,27,7,23,80,81,83,84,85];
      return activityTypes.includes(this.actType)&&!this.venderType;
    },
    keyType() {
      const keyObj = {
        third: 'objectForm',
        thirteen: 'withOrderForm'
      }
      return keyObj[this.activeName]
    },
    orderTips() {
      let str = ""
      if(this.withOrderForm.pointActivityPrizeRemark.remarkActionType==2) {
        str = `<div>
                1.若选择该备注方式，则用户在满足获奖条件后，系统会自动选择一笔符合备注订单条件的已付款待发货的订单打上备注，商家可以把奖品跟订单一起发货给顾客：
              </div>
              <div>
                2.如果获得奖品后，但是限定下单时间范围内无满足“备注订单条件”相关的订单，则用户无法领取该奖品；如果有多笔订单满足，则随机备注一笔订单上。
              </div>`
      } else if(this.withOrderForm.pointActivityPrizeRemark.remarkActionType==0) {
        str = `<div>
          1.若选择该备注方式，则系统只能备注到客户的下一笔符合备注订单条件的已付款待发货的订单中去。用户在满足获奖条件后，还需要在指定时间内完成下单付款，系统才会自动备注，商家可以把奖品跟订单一起发货给顾客；
              </div>
              <div>
                2.如果获得奖品后，但是限定下单时间范围内无满足“备注订单条件”相关的订单，则用户无法领取该奖品；如果限定时间范围内有多笔订单满足备注条件，则随机备注一笔订单上。
              </div>`
      } else {
        str = `<div>
          1.若选择该备注方式，则需要在用户在满足获奖条件后，领取奖品时用户自行选择要备注到指定符合备注订单条件的待发货订单中去，奖品通过备注的方式标记在用户选择的订单上，商家可以把奖品跟订单一起发货给顾客；
              </div>
              <div>
                2.如果用户满足获奖条件后，但是无满足“备注订单条件”相关的订单，则用户无法领取该奖品：
              </div>`
      }
      return str
    },
    isShowManual() {
      return this.actType != 17;
    }
  },
  watch: {
    async dialogVisibleFrom(news) {
      // 回显
      if (news) {
        if (
          this.echoDate.prizeType == 9 ||
          this.echoDate.prizeType == 1 ||
          !this.echoDate.prizeType
        ) {
          if (!this.isShowFirst) {
            this.handleClick({ name: "first" });
            this.prizeGoShop = this.echoDate.prizeGoShop ? JSON.parse(this.echoDate.prizeGoShop) : { goShopSetting: 0, goShopAppId: "", goShopUrl: "" };
            this.selectedCouponId = this.echoDate.assetsId;
            this.couponObj = {
              ...this.echoDate,
              discount: this.echoDate.price,
              name: this.echoDate.title,
            };
            this.couponObj.couponId = this.echoDate.assetsId;
            this.couponObj.id = this.echoDate.assetsId;
            delete this.couponObj.prizeGoShop;
            this.activeName = "first";
          } else {
            this.handleClick({ name: "second" });
            this.activeName = "second";
          }
          // 暂时是隐藏某些项时外传进来的默认值
          if (this.defaultSelect) {
            this.handleClick({ name: this.defaultSelect });
            this.activeName = this.defaultSelect;
          }
        }
        if (this.echoDate.prizeType == 2) {
          this.secondLogo = this.echoDate.logo;
          this.handleClick({ name: "second" });
          this.activeName = "second";
          this.jingduoForm.region = {
            value: this.echoDate.assetsId + "",
            budgetRemain: this.echoDate.budgetRemain,
          };
          this.jingduoForm.count = this.echoDate.price;
          this.jingduoForm.cycleType =  this.echoDate.cycleType || 0
          if (this.isATwoPrice) {
            this.jingduoForm.introduceToUser = this.echoDate.introduceToUser;
          }
          if(this.jingduoForm.cycleType==1) {
            this.jingduoForm.bindPlanList = this.echoDate.bindPlanList;
          }
        }
        if (this.echoDate.prizeType == 3) {
          this.objectForm.isFollowActivityEndTime =
            this.echoDate.isFollowActivityEndTime !== "" &&
            this.echoDate.isFollowActivityEndTime !== undefined &&
            this.echoDate.isFollowActivityEndTime !== null
              ? this.echoDate.isFollowActivityEndTime
              : 1;
          this.objectForm.addressFillEndTime = this.echoDate.addressFillEndTime
            ? this.echoDate.addressFillEndTime
            : "";
          this.objectForm.predictSendTime = this.echoDate.predictSendTime
            ? this.echoDate.predictSendTime
            : "";
            this.objectForm.addressFillLimit =  this.echoDate.addressFillLimit
            // 回显提交地址限制，逗号分隔字符串转数组，兼容旧字段prizeLimit
            const limitValue = this.echoDate.commitAddressLimit || this.echoDate.prizeLimit
            if (limitValue) {
              // 如果是字符串，按逗号分割转数组；如果已经是数组直接使用
              this.objectForm.commitAddressLimit = typeof limitValue === 'string' 
                ? limitValue.split(',').map(Number) 
                : limitValue
            } else {
              this.objectForm.commitAddressLimit = [0]
            }
          if (this.echoDate.isGoodManage) {
            await this.handleClick({ name: "third" });
            this.activeName = "third";
            this.objectForm.resource = "3";
            this.physicalForm.isGoodManage = this.echoDate.isGoodManage;
            this.physicalForm.region = this.echoDate.assetsId + "";
            this.physicalForm.name = this.echoDate.name || this.echoDate.title;
            this.physicalForm.discount = this.echoDate.price;
            this.physicalForm.logo = this.echoDate.logo;
            this.physicalForm.giftType = "1";
            this.physicalForm.singleAmount = 1;
            // A2定制回显
            if (this.isATwoPrice) {
              this.physicalForm.introduce = this.echoDate.introduce;
              this.physicalForm.introducePicUrl =
                this.echoDate.introducePicUrl || [];
              this.physicalForm.introduceToUser = this.echoDate.introduceToUser;
              this.physicalForm.manufacturer = this.echoDate.manufacturer;
              this.physicalForm.cost = this.echoDate.cost;
            }

            this.physicalList.some((item) => {
              if (item.id == this.echoDate.assetsId) {
                this.physicalForm.budgetRemain = item.budgetRemain;
                this.physicalForm.inventoryType = item.inventoryType;
              }
            });
          } else {
            this.handleClick({ name: "third" });
            this.activeName = "third";
            this.objectForm.discount = this.echoDate.price;
            this.objectForm.name = this.echoDate.title;
            this.objectForm.logo = this.echoDate.logo;
            this.objectForm.skuId = this.echoDate.assetsId;
            this.objectForm.resource = this.echoDate.giftType
              ? this.echoDate.giftType + ""
              : "1";
            this.fileList = [
              {
                url: this.echoDate.logo,
                name: this.echoDate.title,
              },
            ];
            //A2定制回显
            if (this.isATwoPrice) {
              this.objectForm = {
                ...this.objectForm,
                introduce: this.echoDate.introduce,
                manufacturer: this.echoDate.manufacturer,
                cost: this.echoDate.cost,
                introduceToUser: this.echoDate.introduceToUser,
              };
              this.introducePicUrl = this.echoDate.introducePicUrl;
            }
              // this.attachInfo = {
              //   shouldCollectExtraData: this.echoDate.shouldCollectExtraData ? this.echoDate.shouldCollectExtraData : 0,
              //   questions: this.echoDate.extraQuestion&&this.echoDate.extraQuestion.title ? [this.echoDate.extraQuestion] : [{type: 1,isMust: 1}],
              // }
            if (this.objectForm.resource == 2) {
              // this.$nextTick(() => {
              //   this.$refs.upload.$children[1].$el.style.display = "none";
              // });
            }
          }
          // 附加信息回显
          this.attachInfo = {
            shouldCollectExtraData: this.echoDate.shouldCollectExtraData ? this.echoDate.shouldCollectExtraData : 0,
            questions: this.echoDate.extraQuestion&&this.echoDate.extraQuestion.title ? [this.echoDate.extraQuestion] : [{type: 1,isMust: 1}],
          }
        } else {
          this.objectForm.name = "";
          this.objectForm.logo = "";
          this.fileList = [];
        }

        if (this.echoDate.prizeType == 4) {
          this.handleClick({ name: "four" });
          this.activeName = "four";
          this.fourLogo = this.echoDate.logo;
          this.integralForm.discount = this.echoDate.singleAmount;
        }
        if (this.echoDate.prizeType == 5) {
          await this.handleClick({ name: "fird" });
          this.activeName = "fird";
          this.firdLogo = this.echoDate.logo;
          this.ekForm.region = this.echoDate.assetsId + "";
          this.ekForm.num = 1;
          let that = this;
          if (this.isATwoPrice) {
            this.ekForm.introduceToUser = this.echoDate.introduceToUser;
          }

          that.eKselectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              console.log(item, "===========>");
              that.ekForm.quantityBalance = item.quantityBalance;
              that.ekForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 6) {
          await this.handleClick({ name: "six" });
          this.activeName = "six";
          this.sixLogo = this.echoDate.logo;
          this.aqyForm.region = this.echoDate.assetsId + "";

          this.aqyForm.num = 1;
          let that = this;

          that.eKselectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              that.aqyForm.quantityBalance = item.quantityBalance;
              that.aqyForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 7) {
          await this.handleClick({ name: "sev" });
          this.activeName = "sev";
          this.sevLogo = this.echoDate.logo;
          this.plusForm.region = this.echoDate.assetsId + "";

          this.plusForm.num = 1;
          let that = this;

          that.eKselectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              that.plusForm.quantityBalance = item.quantityBalance;
              that.plusForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 8) {
          await this.handleClick({ name: "eig" });
          this.activeName = "eig";
          this.eigLogo = this.echoDate.logo;
          this.redForm.region = this.echoDate.assetsId + "";

          // this.redForm.num = 1;
          let that = this;
          that.redSelectList.forEach((item) => {
            if (item.id == that.echoDate.assetsId) {
              that.redForm.quantityBalance = item.quantityTotal
                ? item.quantityTotal - item.quantityActual
                : "";
              that.redForm.num = item.quantityAmount
                ? item.quantityAmount / item.quantityTotal
                : "";
              that.redForm.budgetRemain = item.budgetRemain;
            }
          });
        }
        if (this.echoDate.prizeType == 10) {
          await this.handleClick({ name: "nine" });
          this.activeName = "nine";
          this.nineLogo = this.echoDate.logo;
          this.giftCardForm.region = this.echoDate.assetsId + "";
          this.giftCardForm.num = this.echoDate.price;
          this.giftCardForm.name = this.echoDate.title;
          this.giftCardForm.logo = this.echoDate.logo;
          this.giftCardList.forEach((item) => {
            if (item.id == this.echoDate.assetsId) {
              this.giftCardForm.budgetRemain = item.actualBalance;
            }
          });
        }
        if (this.echoDate.prizeType == 12) {
          if (!this.venderType) {
            await this.handleClick({ name: "eleven" });
            this.activeName = "eleven";
            this.exclusivePriceForm.logo = this.echoDate.logo;
            this.exclusivePriceForm.discount = this.echoDate.price;
            this.exclusivePriceForm.couponId = this.echoDate.assetsId;
            this.exclusivePriceForm.reducePrice = this.echoDate.reducePrice;
            this.exclusiveLoading = true
            getExclusivePricePlanPage({
              current: 1,
              size: 1000000,
              queryType: 0,
            }).then((res) => {
              this.exclusiveLoading = false
              if (res.code == 1) {
                this.actData = res.data.records.filter((i) => {
                  return i.id == this.exclusivePriceForm.couponId;
                });
                this.exclusivePriceForm.name = this.actData[0].name;
              }
            });
          } else {
            this.tokenData = [];
            await this.handleClick({ name: "twelve" });
            this.activeName = "twelve";
            this.tokenForm.logo = this.echoDate.logo;
            this.tokenForm.discount = this.echoDate.price;
            this.tokenForm.couponId = this.echoDate.assetsId || "";
            this.tokenLoading = true;
            promoTokenDetail({ id: this.echoDate.assetsId }).then((res) => {
              this.tokenLoading = false;
              if (res.code == 1) {
                this.tokenData.push(res.data);
                this.tokenForm.name = res.data.name;
              }
            });
          }

          // TODO:库存待定
        }
        // 令牌
        if (this.echoDate.prizeType == 13) {
          await this.handleClick({ name: "twelve" });
          this.activeName = "twelve";
          this.tokenForm.logo = this.echoDate.logo;
          this.tokenForm.discount = this.echoDate.price;
          this.tokenForm.couponId = this.echoDate.assetsId || "";
          this.tokenLoading = true;
          promoTokenDetail({ id: this.echoDate.assetsId }).then((res) => {
            this.tokenLoading = false;
            if (res.code == 1) {
              this.tokenData.push(res.data);
              this.tokenForm.name = res.data.name;
            }
          });
        }
        // 实物奖品（随单发）
        if (this.echoDate.prizeType == 14) {
          if (this.echoDate.isGoodManage) {
            await this.handleClick({ name: "thirteen" });
            this.activeName = "thirteen";
            this.withOrderForm.resource = "3";
            this.physicalForm.isGoodManage = this.echoDate.isGoodManage;
            this.physicalForm.region = this.echoDate.assetsId + "";
            this.physicalForm.name = this.echoDate.name || this.echoDate.title;
            this.physicalForm.discount = this.echoDate.price;
            this.physicalForm.logo = this.echoDate.logo;
            this.physicalForm.giftType = "1";
            this.physicalForm.singleAmount = 1;

            this.physicalList.some((item) => {
              if (item.id == this.echoDate.assetsId) {
                this.physicalForm.budgetRemain = item.budgetRemain;
                this.physicalForm.inventoryType = item.inventoryType;
              }
            });
          } else {
            this.handleClick({ name: "thirteen" });
            this.activeName = "thirteen";
            this.withOrderForm.discount = this.echoDate.price;
            this.withOrderForm.name = this.echoDate.title;
            this.withOrderForm.logo = this.echoDate.logo;
            this.withOrderForm.skuId = this.echoDate.assetsId;
            this.withOrderForm.resource = this.echoDate.giftType
              ? this.echoDate.giftType + ""
              : "1";
            this.fileList = [
              {
                url: this.echoDate.logo,
                name: this.echoDate.title,
              },
            ];
          }
          // 新增字段
          this.withOrderForm.pointActivityPrizeRemark = this.echoDate.pointActivityPrizeRemark;
          if(this.withOrderForm.pointActivityPrizeRemark.skuMatchType!=0&&this.withOrderForm.pointActivityPrizeRemark.skuIds){
            this.getExcludeOrSpecifyList()
          }
        }
      }
      // 禁止梯度奖品选择第二个京豆奖品
      // var jinDou,jinDou1
      // if(this.$parent.itemArr){
      //   jinDou = this.$parent.itemArr.some((i) => {
      //     return i.prizeType == 2;
      //   });
      // }
      // if(this.$parent.tableData){
      //   jinDou1 = this.$parent.tableData.some((i) => {
      //     return i.prizeType == 2;
      //   });
      // }
      // var tj2 = this.$parent.clickActual1;
      // 修改京东奖品时不置灰
      // var tj3 = this.$parent.echoDate.prizeType == 2

      // console.log('itemArr',jinDou,'tableData',jinDou1,'ech',this.$parent.echoDate,tj3);
      // this.jdActual = jinDou&&!tj3 ? true : false;

      if (this.isShowFirst && this.jdActual) {
        this.activeName = "third";
      }

      this.$nextTick(() => {
        // this.$refs.inputForms && this.$refs.inputForms.formSearch();
        this.$refs.inputForms && this.$refs.inputForms.handleSearch();
      });
    },
    venderType: {
      handler(newVal) {
        if (newVal) {
          this.getSupplierList();
          this.jdTableInfo[0].width = 280;
        } else {
          this.jdTableInfo[0].width = 150;
        }
      },
      immediate: true,
    },
    venderId: {
      handler(newVal) {
        if (newVal && this.venderType) {
          this.formAccount.accountCode = newVal;
          this.formAccount.accountType = "1";
          this.getJingdouList();
        }
      },
      immediate: true,
    },
    accountCode: {
      handler(newVal) {
        if (newVal) {
          if (newVal == "商家账户") {
            this.formAccount.accountType = "1";
            this.formAccount.accountCode = this.venderId;
          } else {
            this.formAccount.accountCode = newVal;
            this.formAccount.accountType = "2";
          }
          this.jingduoForm.region = "";
          this.getJingdouList();
        }
      },
    },
  },
  provide() {
    return {
      isShowPhoneInput: false,
      isShowPictureSingle: false,
      isShowPicUpload: false,
      isShowMatrix: false,
      isShowMoreSelect: false,
      isShowMultipleType: false,
      isShowMultipleMatrixType: false,
      isShowMultipleFillInType: false,
    };
  },
  data() {
    return {
      selectedCouponId: "",
      // 优惠券去使用链接配置
      prizeGoShop: {
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: ""
      },
      couponObj: {},
      goodsLoading: false,
      isShowExclude: false,
      excludeOrSpecifyList: [],
      sureLoading: false,
      // 1.46迭代新增专享价
      exclusiveLoading:false,
      tokenLoading: false,
      tokenRules: {
        logo: [
          {
            required: true,
            message: "请上传奖品图",
            trigger: "change",
          },
        ],
        couponId: [
          {
            required: true,
            message: "请选择令牌",
            trigger: "change",
          },
        ],
      },
      exclusiveRules: {
        logo: [
          {
            required: true,
            message: "请上传奖品图",
            trigger: "change",
          },
        ],
        couponId: [
          {
            required: true,
            message: "请选择专享价活动",
            trigger: "change",
          },
        ],
      },
      actData: [],
      tokenData: [],
      actTableInfo: [
        {
          label: "专享价名称",
          prop: "name",
        },
        {
          label: "优惠价格",
          prop: "price",
          slot: "priceSlot",
        },
        {
          label: "剩余数量（人数）",
          prop: "quantityBalance",
        },
        {
          label: "操作",
          prop: "action",
          slot: "actionSlot",
        },
      ],
      tokenTableInfo: [
        {
          label: "令牌名称",
          prop: "name",
        },
        {
          label: "令牌ID",
          prop: "tokenId",
        },
        {
          label: "令牌密钥",
          prop: "secretKey",
        },
        {
          label: "令牌有效时间",
          slot: "timeSlot",
        },
        {
          label: "操作",
          prop: "action",
          slot: "actionSlot",
        },
      ],
      exclusivePriceForm: {
        logo: "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png",
        name: "",
        discount: "",
        couponId: "",
        reducePrice: ""
      },
      isShowExclusive: false,
      isShowToken: false,
      tokenForm: {
        logo: "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png",
        name: "",
        couponId: "",
        discount: 0,
      },
      secondLogo:'https://cdn-image.yucrm.cn/5a6fc854abbd4a4882def758d8f578f4.png', // 金豆
      fourLogo:
        "https://cdn-image.yucrm.cn/e5250807717b404f8296bee167c668d1.png", // 积分
      firdLogo:
        "https://cdn-image.yucrm.cn/aab7875b7cb34e15a0acca8eac7f0045.png", // 京东E卡
      sixLogo:
        "https://cdn-image.yucrm.cn/6760b46a47da4fc1ac557c7ca8a7c0d9.png", // 爱奇艺
      sevLogo:
        "https://cdn-image.yucrm.cn/9133d3b3a0da434f8b0512cc1b3a684a.png", // PLUS会员
      eigLogo:
        "https://cdn-image.yucrm.cn/ab7f7d3e28594787b34970f084cb8337.png", // 红包
      nineLogo:
        "https://cdn-image.yucrm.cn/01ffdba6acaa43c48423cda39e99cb5e.png", // 礼品卡
      elevenLogo:
        "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png", // 专享价
      twelveLogo:
        "https://cdn-image.yucrm.cn/96a42448b954472ebdc825c4d4af7268.png", // 令牌

      cascaderList: [],
      formData: {
        current: 1,
        size: 9999999,
      },
      physicalList: [],
      isShowGift: false,
      giftCardList: [],
      formAccount: {
        accountCode: "",
        accountType: "",
      },
      accountCode: "商家账户",
      accountCodeList: [],
      isOpenJinDou: false,
      addCouponIsShow: false,
      inputDataTwo: [
        {
          label: "优惠券名称：",
          prop: "name",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "优惠券id/key：",
          prop: "couponIdOrPutKey",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "奖品状态：",
          prop: "status",
          type: "Select",
          placeholder: "请选择",
          options: [
            { label: "全部", value: null },
            { label: "未开始", value: 1 },
            { label: "进行中", value: 2 },
            { label: "已结束", value: 3 },
          ],
        },
        {
          label: "优惠券使用范围：",
          prop: "couponKind",
          placeholder: "请选择",
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "全店", value: 2 },
            { label: "商品", value: 3 },
            { label: "全品类", value: 0 },
            { label: "限品类", value: 1 },
          ],
        },
        {
          label: "创建时间：",
          type: "DateRange",
          dateType: "datetime",
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          startTime: this.getDateStr(-30) + " 00:00:00",
          endTime: this.getDateStr(0) + " 23:59:59",
          startKey: "beginTime",
          endKey: "endTime",
          defalutLimit: true,
        },
      ],
      // inputDataTwo: [
      //   {
      //     name: "优惠券名称:",
      //     val: "name",
      //     placeholder: "请输入",
      //   },
      //   {
      //     name: "优惠券id/key:",
      //     val: "couponIdOrPutKey",
      //     placeholder: "请输入",
      //   },
      //   {
      //     name: "奖品状态:",
      //     val: "status",
      //     placeholder: "请选择",
      //     selectArr: [
      //       { label: "全部", id: null },
      //       { label: "未开始", id: 1 },
      //       { label: "进行中", id: 2 },
      //       { label: "已结束", id: 3 },
      //     ],
      //   },
      //   {
      //     name: "优惠券使用范围:",
      //     val: "couponKind",
      //     placeholder: "请选择",
      //     selectArr: [
      //       { label: "全部", id: null },
      //       { label: "全店", id: 2 },
      //       { label: "商品", id: 3 },
      //       { label: "全品类", id: 0 },
      //       { label: "限品类", id: 1 },
      //     ],
      //   },
      //   {
      //     name: "创建时间:",
      //     myDate: true,
      //     val: ["beginTime", "endTime"],
      //     startPlaceholder: "开始日期",
      //     endPlaceholder: "结束日期",
      //     isdefault: true,
      //   },
      // ],
      awardSettingsLsit: [
        {
          prizeType: 1,
          price: null,
          title: "",
          singleAmount: null,
          totalAmount: "",
          inviteNum: null,
          takeEndTime: null,
          takeBeginTime: null,
          isMain: 1,
          quota: null,
        },
      ],
      FissionVoucherList: [],
      addCouponIsShow2: false,

      isPointsEnabled: false,
      // isShowFirst: true, //邀请开卡活动隐藏优惠券一栏
      actual: false,
      jdActual: false,
      fileList: [],
      form: {
        imageUrl: "",
      },
      dialogFormVisible: false,
      // returnSelectGoods: [],
      returnSelectGoodsAppoint: [], //选择商品回显
      postForm: {
        orderStartTime: "",
        testSelect: 0,
      },
      goodsStateLength: 0,
      goodsStateLength1: 0,
      selectList: [],
      eKselectList: [],
      redSelectList: [],
      tableLoading: true,
      loading: false,
      activeName: "first",
      listName: this.Sans ? "second" : "first",
      // 互动任务-店铺礼包、每日抢、评价有礼、裂变神券、天降红包雨】、【互动乐园-幸运抽奖 默认京券 免费领取 不公开
      inputData: [
        {
          name: "类型:",
          val: "type",
          placeholder: "请选择",
          selectArr: [
            { label: "京券", id: 0, defaultValue: 0 },
            { label: "东券", id: 1 },
          ],
        },
        {
          name: "发放类型:",
          val: "grantType",
          placeholder: "请选择",
          selectArr: [
            { label: "促销绑定", id: 1, defaultValue: 3, disabled: true },
            { label: "推送", id: 2, disabled: true },
            { label: "免费领取", id: 3, disabled: false },
            { label: "京豆换券", id: 4, disabled: true },
            { label: "互动平台", id: 5, disabled: true },
          ],
        },
        {
          name: "是否公开:",
          val: "display",
          placeholder: "请输入",
          selectArr: [
            { label: "不公开", id: 1, defaultValue: 1 },
            { label: "公开", id: 3 },
          ],
        },
      ],
      internalTable: [],
      externalTable: [],
      totalNum: 0,
      totalNumTwo: 0,
      jingduoForm: {
        count: null,
        region: {
          budgetRemain: "",
        },
        cycleType: 0,//京豆计划-活动周期：0-活动时长90天内，1-活动时长大于90天
        accountCode: "",//京豆计划-账号编码
        bindPlanList: [
          {
              id: "", //京豆计划
              startTime: "", //计划开始时间
              endTime: "", //计划结束时间
              sendBeanType: 0, //单次发放京东数量类型，0:1~1000 1:1~50000
              useStartTime: "", //使用开始时间
              useEndTime: "", //使用结束时间
              singleAmount: "", //单份奖励数量
              totalAmount: "", //总共奖品数量 -1表示无限制
              sendTimes: "", //发豆次数
              budgetRemain: "", //剩余京豆预算
          }
        ]//绑定京豆计划列表
      },
      objectForm: {
        logo: "",
        resource: "1",
        name: "",
        discount: null,
        isFollowActivityEndTime: 1,
        addressFillEndTime: "",
        predictSendTime: "",
        addressFillLimit: 0,
        commitAddressLimit: [0],
      },
      giftCardForm: {
        region: "",
        logo: "",
        num: "1",
        budgetRemain: "",
        name: "",
        singleAmount: 1,
      },
      physicalForm: {
        region: "",
        logo: "",
        discount: "",
        budgetRemain: "",
        name: "",
        giftType: "1",
        singleAmount: 1,
        isGoodManage: 1,
        inventoryType: 0,
        // A2定制
        isShowPrizeInfo: false,
        introducePicUrl: [],
        manufacturer: "",
        cost: "",
        introduceToUser: "",
        introduce: "",
      },
      integralForm: {
        discount: null,
      },
      ekForm: {
        quantityBalance: 0,
        budgetRemain: 0,
        region: null,
      },
      aqyForm: {
        quantityBalance: 0,
        budgetRemain: 0,
        region: null,
      },
      plusForm: {
        quantityBalance: 0,
        budgetRemain: 0,
        region: null,
      },
      redForm: {
        num: "",
        quantityBalance: 0,
        budgetRemain: 0,
        region: "",
      },
      giftCardForm: {
        num: "",
        budgetRemain: 0,
        region: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      dialogVisibleFrom: this.isShow,
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
        issueType: 0,
      },
      formLitJD: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      },
      formLitZC: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      },
      formLitRed: {
        current: 1,
        size: 100,
        isFilterUsed: true,
        status: 4,
      },
      jingdouData: {},
      tabActive: 3,
      selectZCList: {},
      zcData: {},
      commodityList: [
        {
          label: "商品类目：",
          placeholder: "请选择",
          prop: "categoryId",
          type: "cascader",
          options: [],
          props: { multiple: true },
          width: 240,
        },
        {
          label: "SKU ID：",
          prop: "skuId",
          placeholder: "请输入SKU ID",
          inputType: "number",
          type: "Input",
          width: 240,
        },
        {
          label: "商品名称：",
          prop: "skuName",
          placeholder: "请输入商品名称",
          type: "Input",
          width: 240,
        },
        {
          label: "商品状态：",
          prop: "skuStatus",
          value: 1,
          type: "Select",
          options: [
            { label: "全部", value: null },
            { label: "上架", value: 1 },
            { label: "下架", value: 2 },
          ],
          width: 136,
        },
      ],
      tableShopData: [],
      totalListThr: 0,
      formShopList: { current: 1, size: 5, skuStatus: 1 },
      nowTime: "",
      activeSendtimes: "",
      planList: {
        jingdou: {},
      },
      introducePicUrl: [],
      isShowPrizeInfo: false, // 是否显示奖品信息
      introduceToUser: "", // 奖品介绍-仅A2
      // 附加信息
      attachInfo: {
        shouldCollectExtraData: 0,
        questions: [{type: 1,isMust: '1'}]
      },
      withOrderForm: {
        logo: "",
        resource: "1",
        name: "",
        discount: null,
        skuId: "",
        pointActivityPrizeRemark: {
          content: "",
          remarkActionType: 2,
          startOrderTime: "",
          endOrderTime: "",
          receivePayment: "",
          skuMatchType: 0,
          tradeLimitTime: "",
          tradeLimitTimeUnit: 2,
          skuIds: "",
          // loseEfficacyRemark: "",
        }
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.withOrderForm.pointActivityPrizeRemark.endOrderTime) {
            return time.getTime() > new Date(this.withOrderForm.pointActivityPrizeRemark.endOrderTime).valueOf()
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.withOrderForm.pointActivityPrizeRemark.startOrderTime||this.actEndTime) {
              return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.withOrderForm.pointActivityPrizeRemark.startOrderTime).valueOf() || time.getTime() > new Date(this.actEndTime).valueOf()
          } else {
              return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      jdTableInfo: [
        {
          label: "计划名称",
          prop: "name",
          width: 150,
          slot: "nameSlot",
        },
        {
          label: "计划时间",
          prop: "palnTime", 
          width: 200,
          slot: "palnTimeSlot",
        },
        {
          label: "使用计划时段",
          prop: "useTime",
          slot: "useTimeSlot",
          width: 240,
        },
        {
          label: "发豆次数（最多）",
          prop: "sendTimes",
          width: 150,
        },
        {
          label: "剩余京豆预算",
          prop: "budgetRemain",
          width: 150,
        },
        {
          label: "单份奖励个数",
          prop: "singleAmount",
          slot: "singleAmountSlot",
          width: 150,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          width: 150,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          width: 150,
          fixed: "right",
        },
      ],
    };
  },
  mounted() {
    // 类型默认
    this.inputData[0].selectArr[0].defaultValue = this.typeDefault.type;
    // 是否公开
    this.inputData[2].selectArr[0].defaultValue = this.typeDefault.display;
    // 发放类型 禁用
    this.inputData[1].selectArr[0].defaultValue = this.typeDefault.grantType;
    if (this.typeDefault && this.typeDefault.noDisabled) {
      this.inputData[1].selectArr.forEach((item) => {
        this.typeDefault.noDisabled.forEach((i) => {
          if (item.id === i) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        });
      });
    }
    this.formList.type = this.typeDefault.type;
    this.formList.display = this.typeDefault.display;
    this.formList.grantType = this.typeDefault.grantType;
    judgingActivation().then((res) => {
      this.isPointsEnabled = res.data;
    });
    // this.quireList();
    // this.getShopList();
    this.getSeller();
    this.getIsauth();
    if (!this.Sans) {
      this.querySellerCouponExternal();
    }
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.$refs.inputForms.formSearch();
    //   }, 10);
    // });
    // 邀请开卡v3.4
    if (this.$parent.localStepNum == 4 || this.$parent.localStepNum == 5) {
      // this.setDefalut();

      var tj1 = this.$parent.tableData.some((i) => {
        return i.prizeType == 3;
      });

      // 点击到已选实物奖品的条件，不置灰实物tab
      var tj2 = this.$parent.clickActual;
      // this.actual = tj1 && tj2 ? true : false;

      // this.isShowFirst = true;
      // this.activeName = "second";
    }
    // var jinDou = this.$parent.tableData.some((i) => {
    //   return i.prizeType == 2;
    // });
    // this.jdActual = jinDou ? true : false;
    // console.log(jinDou);
  },
  methods: {
    handleSubmitCoupon() {
      // 跳转链接校验
      if (this.prizeGoShop.goShopSetting == 1 && !this.prizeGoShop.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.prizeGoShop.goShopSetting == 2) {
        if (!this.prizeGoShop.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.prizeGoShop.goShopUrl.startsWith("https://") ||
          !this.prizeGoShop.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      this.dialogVisibleFrom = false;
      this.$emit("choose-shop",{...this.couponObj,prizeGoShop: JSON.stringify(this.prizeGoShop)}, 1);
    },
    onShopSetChange(value) {
      this.prizeGoShop.goShopAppId = "";
      this.prizeGoShop.goShopUrl = "";
    },
    changeCycleType() {
      this.jingduoForm.bindPlanList = [{
        id: "", //京豆计划
        startTime: "", //计划开始时间
        endTime: "", //计划结束时间
        sendBeanType: 0, //单次发放京东数量类型，0:1~1000 1:1~50000
        useStartTime: "", //使用开始时间
        useEndTime: "", //使用结束时间
        singleAmount: "", //单份奖励数量
        totalAmount: "", //总共奖品数量 -1表示无限制
        sendTimes: "", //发豆次数
        budgetRemain: "", //剩余京豆预算
      }]
      this.jingduoForm.count = null;
      this.jingduoForm.region = {
        budgetRemain: "",
      };
    },
    getUseStartPickerOptions(row) {
      return {
        disabledDate: (time) => {
          // 不能早于京豆计划本身开始时间
          if (row.startTime) {
            if (time.getTime() < new Date(row.startTime).valueOf()) {
              return true;
            }
          }
          // 不能晚于使用结束时间
          if (row.useEndTime) {
            if (time.getTime() > new Date(row.useEndTime).valueOf()) {
              return true;
            }
          }
          // 不能晚于京豆计划本身结束时间
          if (row.endTime) {
            if (time.getTime() > new Date(row.endTime).valueOf()) {
              return true;
            }
          }
          return false;
        },
      };
    },
    getUseEndPickerOptions(row,rowIndex) {
      return {
        disabledDate: (time) => {
          // 不能早于京豆计划本身开始时间
          if (row.startTime) {
            if (time.getTime() < new Date(row.startTime).valueOf()) {
              return true;
            }
          }
          // 不能早于使用开始时间
          if (row.useStartTime) {
            if (time.getTime() < new Date(row.useStartTime).valueOf()) {
              return true;
            }
          }
          // 不能晚于京豆计划本身结束时间
          if (row.endTime) {
            if (time.getTime() > new Date(row.endTime).valueOf()) {
              return true;
            }
          }
          return false;
        },
      };
    },
    handleUseStartTimeChange(row) {
      if (row.useEndTime && new Date(row.useEndTime) < new Date(row.useStartTime)) {
        row.useEndTime = "";
      }
    },
    handleAddJd() {
      if(this.jingduoForm.bindPlanList.length >= 10) {
        this.$message.warning(`最多只能增加10个计划`);
        return
      }
      this.jingduoForm.bindPlanList.push({
        id: "", //京豆计划
        startTime: "", //计划开始时间
        endTime: "", //计划结束时间
        sendBeanType: 0, //单次发放京东数量类型，0:1~1000 1:1~50000
        useStartTime: "", //使用开始时间
        useEndTime: "", //使用结束时间
        singleAmount: "", //单份奖励数量
        totalAmount: "", //总共奖品数量 -1表示无限制
        sendTimes: "", //发豆次数
        budgetRemain: "", //剩余京豆预算
      })
    },
    checkJdSingleIn(e, row) {
      let filtered = e.replace(/^0|[^\d]/g, "");
      let newVal = Number(filtered);
      if (newVal < 1) {
        newVal = "";
      } else if (row && row.budgetRemain && newVal > row.budgetRemain) {
        newVal = row.budgetRemain;
        this.$message.warning(`单份奖励个数不能大于剩余京豆预算${row.budgetRemain}`);
      }
      this.jingduoForm.bindPlanList.forEach(item => {
        item.singleAmount = newVal;
      });
      return newVal;
    },
    checkJdTotalIn(e, row) {
      let filtered = e.replace(/^0|[^\d]/g, "");
      let newVal = Number(filtered);
      if (newVal < 1) {
        newVal = "";
      } else if (row && row.budgetRemain && row.singleAmount) {
        const total = newVal * row.singleAmount;
        if (total > row.budgetRemain) {
          newVal = Math.floor(row.budgetRemain / row.singleAmount);
          this.$message.warning(`奖品数量乘以单份奖励个数不能大于剩余京豆预算${row.budgetRemain}`);
        }
      }
      return newVal;
    },
    handleDeleteJd(index) {
      this.jingduoForm.bindPlanList.splice(index, 1)
    },
    // 选择京豆计划处理
    handleSelectJduoChange(row,id) {
     const obj = this.selectList.find((item) => item.id == id)
     if(obj) {
      row.startTime = obj.startTime
      row.endTime = obj.endTime
      row.sendTimes = obj.sendTimes
      row.budgetRemain = obj.budgetRemain
     }
    },
    handleRowAccountCodeChange(newVal, row) {
      if (newVal) {
        if (newVal == "商家账户") {
          row.accountType = "1";
          row.accountCode = this.venderId;
        } else {
          row.accountCode = newVal;
          row.accountType = "2";
        }
        this.jingduoForm.region = "";
        this.getJingdouList();
      }
    },
    // 查询指定商品
    getExcludeOrSpecifyList() {
      this.goodsLoading = true
      const skuIds = this.withOrderForm.pointActivityPrizeRemark.skuIds.split(",")
      getTaobaoItemListSku({
        current: 1,
        size: skuIds.length,
        skuIds,
      }).then((res) => {
        this.goodsLoading = false
        if(res.code==1) {
          this.excludeOrSpecifyList = res.data.records;
        }
      });
    },
    handleChangeRemarkType() {
      this.withOrderForm.pointActivityPrizeRemark.startOrderTime = "";
      this.withOrderForm.pointActivityPrizeRemark.endOrderTime = "";
      this.withOrderForm.pointActivityPrizeRemark.tradeLimitTime = "";
      this.withOrderForm.pointActivityPrizeRemark.tradeLimitTimeUnit = 2;
    },
    selectExcludeGoods() {
      this.isShowExclude  = true;
    },
    getSpecifyOrExcludeGoods(data) {
      this.excludeOrSpecifyList = [];
      this.withOrderForm.pointActivityPrizeRemark.skuIds = ""
      if (data && data.length > 0) {
        this.excludeOrSpecifyList = data;
        this.withOrderForm.pointActivityPrizeRemark.skuIds = data.map((item) => item.skuId).join(",");
      }
      this.isShowExclude = false;
    },
    handleChangeProductType(val) {
      if(val == 0) {
        this.excludeOrSpecifyList = []
        this.withOrderForm.pointActivityPrizeRemark.skuIds = ""
      }
    },
    clearTime() {
      this.withOrderForm.pointActivityPrizeRemark.startOrderTime = "";
      this.withOrderForm.pointActivityPrizeRemark.endOrderTime = "";
    },
    activityTimeChange(val) {
      // 下单结束时间需小于活动结束时间
      if(val) {
        if(new Date(val).valueOf() > new Date(this.actEndTime).valueOf()) {
          this.$message.warning("下单结束时间需小于活动结束时间")
          this.withOrderForm.pointActivityPrizeRemark.endOrderTime = ""
        }
      }
    },
    // 1.46迭代新增专享价
    confirmExclusive(val) {
      if(this.isBindGoods&&this.specifyId) {
        if(this.hasSelectIds.includes(val.id)) {
          this.$message.warning("该专享价已存在")
          return
        }
        if(!val.skuList.some((item)=>item.skuId==this.specifyId)) {
          this.$message.warning("需选择与指定商品相关专属价")
          return
        }
        let obj = val.skuList.find((item)=>item.skuId==this.specifyId)
        if(obj) {
          this.exclusivePriceForm.discount = obj.payPrice;
          this.exclusivePriceForm.logo = obj.logo;
          this.exclusivePriceForm.reducePrice = obj.discountAmount
        }
      } else {
        this.exclusivePriceForm.discount = val.minPayPrice;
      }
      this.exclusivePriceForm.name = val.name;
      this.exclusivePriceForm.couponId = val.id;
      this.actData = [];
      this.actData.push(val);
      this.isShowExclusive = false
    },
    // 选择令牌
    confirmToken(val) {
      if(this.isBindGoods&&this.specifyId) {
        if(this.hasSelectIds.includes(val.id)) {
          this.$message.warning("该令牌已存在")
          return
        }
        let list = val.detailList[0].giveSkuList
        if(!list.some((item)=>item.skuId==this.specifyId)) {
          this.$message.warning("需选择与指定商品相关令牌")
          return
        }
        let obj = list.find((item)=>item.skuId==this.specifyId)
        if(obj) {
          this.tokenForm.logo = obj.logo;
          this.tokenForm.discount = "";
        }
      } else {
        this.tokenForm.discount = 0;
      }
      this.tokenData = [];
      this.tokenData.push(val);
      this.tokenForm.couponId = val.id;
      this.tokenForm.name = val.name;
      this.isShowToken = false
    },
    // 移除专享价
    removeAct(index) {
      this.actData.splice(index, 1);
      this.exclusivePriceForm.couponId = "";
    },
    // 移除令牌
    removeToken(index) {
      this.tokenData.splice(index, 1);
      this.tokenForm.couponId = "";
    },
    submitExclusivePriceForm(tabName) {
      this.$refs[tabName].validate((valid) => {
        if (valid) {
          this.dialogVisibleFrom = false;
          const zcData = {
            ...this.exclusivePriceForm,
            couponId: this.exclusivePriceForm.couponId,
            singleAmount: 1,
          };
          this.$emit("choose-shop", zcData, 12);
        } else {
          return false;
        }
      });
    },
    submitTokenForm(tabName) {
      this.$refs[tabName].validate((valid) => {
        if (valid) {
          this.dialogVisibleFrom = false;
          const zcData = {
            ...this.tokenForm,
            singleAmount: 1,
          };
          this.$emit("choose-shop", zcData, 13);
        } else {
          return false;
        }
      });
    },
    selectExclusivePrice() {
      this.isShowExclusive = true;
    },
    selectToken() {
      this.isShowToken = true;
    },
    // 收集题目
    collectQuestion(question) {
      this.attachInfo.questions = question;
    },
    refreshGiftCard() {
      this.getGiftCardList();
    },
    // v1.18新增 查询实物（实物管理）
    async getPhysical() {
      try {
        let arr = [];
        if (this.$parent.activityData) {
          if (this.$parent.activityData.id == 36) {
            // 打榜有礼特殊处理
            this.$parent.editableTabs.forEach((tabs) => {
              tabs.content.forEach((item) => {
                if (item.prizeType == 3 && item.isGoodManage == 1) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            });
          } else if (
            this.$parent.activityData.id != 4 &&
            this.$parent.activityData.id != 5
          ) {
            this.$parent.itemArr.forEach((item) => {
              if (item.prizeType == 3 && item.isGoodManage == 1) {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  arr.push(item.assetsId);
                }
              }
            });
            if (this.$parent.awardSettingsLsit) {
              console.log(
                this.$parent.awardSettingsLsit,
                "this.$parent.awardSettingsLsit===>"
              );
              this.$parent.awardSettingsLsit.forEach((item) => {
                if (item.prizeType == 3 && item.isGoodManage == 1) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            }
          } else {
            // 邀请关注和邀请开卡有三种奖品类型，分开处理
            // 奖品类型 0统一(awardSettingsLsit) 1梯度(itemArr) 2任务(taskTableData)
            if (this.$parent.ruleForm.isCumulativePrize == 0) {
              if (this.$parent.awardSettingsLsit) {
                this.$parent.awardSettingsLsit.forEach((item) => {
                  if (item.prizeType == 3 && item.isGoodManage == 1) {
                    if (item.assetsId != this.$parent.echoDate.assetsId) {
                      arr.push(item.assetsId);
                    }
                  }
                });
              }
            } else if (this.$parent.ruleForm.isCumulativePrize == 1) {
              this.$parent.itemArr.forEach((item) => {
                if (item.prizeType == 3 && item.isGoodManage == 1) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            } else if (this.$parent.ruleForm.isCumulativePrize == 2) {
              this.$parent.taskTableData.forEach((item) => {
                if (item.prizeType == 3 && item.isGoodManage == 1) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            }
          }
        }
        let params = {
          ...this.formData,
          activityId: this.actId ? this.actId.id : "",
          idList: arr.join(","),
        };
        this.tableLoading = true;
        const res = await getGoodsPage(params);
        if (res.code == 1) {
          this.tableLoading = false;
          let selectArr = res.data.records.map((item) => {
            return {
              label: item.goodsName,
              ...item,
            };
          });
          this.physicalList = selectArr;
        }
      } catch (error) {
        this.tableLoading = false;
      }
    },
    // v1.18新增礼品卡
    async getGiftCardList() {
      try {
        let arr = [];
        if (this.$parent.activityData) {
          if (this.$parent.activityData.id == 36) {
            // 打榜有礼特殊处理
            this.$parent.editableTabs.forEach((tabs) => {
              tabs.content.forEach((item) => {
                if (item.prizeType == 10) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            });
          } else if (
            this.$parent.activityData.id != 4 &&
            this.$parent.activityData.id != 5
          ) {
            this.$parent.itemArr.forEach((item) => {
              if (item.prizeType == 10) {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  arr.push(item.assetsId);
                }
              }
            });
            if (this.$parent.awardSettingsLsit) {
              console.log(
                this.$parent.awardSettingsLsit,
                "this.$parent.awardSettingsLsit===>"
              );
              this.$parent.awardSettingsLsit.forEach((item) => {
                if (item.prizeType == 10) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            }
          } else {
            // 邀请关注和邀请开卡有三种奖品类型，分开处理
            // 奖品类型 0统一(awardSettingsLsit) 1梯度(itemArr) 2任务(taskTableData)
            if (this.$parent.ruleForm.isCumulativePrize == 0) {
              if (this.$parent.awardSettingsLsit) {
                this.$parent.awardSettingsLsit.forEach((item) => {
                  if (item.prizeType == 10) {
                    if (item.assetsId != this.$parent.echoDate.assetsId) {
                      arr.push(item.assetsId);
                    }
                  }
                });
              }
            } else if (this.$parent.ruleForm.isCumulativePrize == 1) {
              this.$parent.itemArr.forEach((item) => {
                if (item.prizeType == 10) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            } else if (this.$parent.ruleForm.isCumulativePrize == 2) {
              this.$parent.taskTableData.forEach((item) => {
                if (item.prizeType == 10) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            }
          }
        }
        this.loading = true;
        let params = {
          current: 1,
          size: 10000,
          status: 2,
          isFilterUsed: true,
          activityId: this.actId ? this.actId.id : "",
          idStr: arr.join(","),
        };
        if (!this.notBaidu) {
          params.all = false;
        }
        const res = await getGiftCardPage(params);
        this.loading = false;
        if (res.code == 1) {
          let selectArr = res.data.records.map((item) => {
            return {
              ...item,
              label: item.planName,
            };
          });
          // 过滤出当前活动未使用的计划
          this.giftCardList = selectArr;
        }
      } catch (error) {}
    },
    async getSupplierList() {
      try {
        const res = await getSupplierAccountList();
        if (res.code == 1) {
          let list = res.data;
          this.accountCodeList = list.map((item) => {
            let obj = {};
            obj["accountCode"] = item;
            return obj;
          });
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          });
        } else {
          this.accountCodeList.unshift({
            accountCode: "商家账户",
          });
        }
      } catch (error) {}
    },
    // 查询是否开通京豆计划
    async getIsauth() {
      const res = await isauth();
      if (res.code == 1) {
        this.isOpenJinDou = res.data;
      } else {
        this.isOpenJinDou = false;
      }
    },
    handleSizeChange2(val) {
      this.formListTwo.size = val;
      this.quireList();
    },
    handleCurrentChange2(val) {
      this.formListTwo.current = val;
      this.quireList();
    },
    addStatus(val) {
      let obj = val;
      createSellerCouponWrite(obj)
        .then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            // this.$refs.inputForms.formSearch();
            this.$refs.inputForms.handleSearch();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
      // this.awardSettingsLsit[0].assetsId = data
      return;
    },
    addStatus2() {
      // this.$refs.inputForm.formSearch();
      // this.$refs.inputForms.formSearch();
      this.$refs.inputForms.handleSearch();
    },
    searchContentTwo(val) {
      this.formListTwo = {
        isTake: 1,
        current: 1,
        size: this.formListTwo.size,
        ...val,
      };
      this.querySellerCouponExternal();
    },
    handleAddCoupon() {
      this.addCouponIsShow = true;
      // this.echoDate = {}
    },
    handleAddCoupon2() {
      this.addCouponIsShow2 = true;
      // this.echoDate2 = {}
    },
    // 京豆充值教程
    toJdTeach() {
      window.open(
        "https://www.yuque.com/yunduanxincrm/flgan6/wm6y952zt56lgu6b"
      );
    },

    handlelink() {
      window.open("https://member.shop.jd.com/index/newmemberlevel");
    },
    planChange(val) {
      this.activeSendtimes = val.sendTimes;
    },
    setDefalut() {
      if (this.putPrize.prizeType) {
      }
    },
    resetForm() {
      this.objectForm.isFollowActivityEndTime = 1
      this.objectForm.addressFillEndTime = ""
      this.objectForm.predictSendTime = ""
      this.objectForm.addressFillLimit = 0
      this.objectForm.commitAddressLimit = [0]
      this.attachInfo = {
        shouldCollectExtraData: 0,
        questions: [{type: 1,isMust: '1'}]
      }
    },
    handleCommitAddressLimitChange(label, checked) {
      // 提交地址限制互斥逻辑
      if (label === 0) {
        // 勾选"不限制"时，清空其他所有选项
        if (checked) {
          this.objectForm.commitAddressLimit = [0]
        }
      } else {
        if (checked) {
          // 勾选其他选项时，移除"不限制"
          const index = this.objectForm.commitAddressLimit.indexOf(0)
          if (index > -1) {
            this.objectForm.commitAddressLimit.splice(index, 1)
          }
        } else {
          // 取消其他选项时，如果没有选中任何其他限制，则自动选中"不限制"
          const hasOtherLimit = this.objectForm.commitAddressLimit.some(item => item !== 0)
          if (!hasOtherLimit && this.objectForm.commitAddressLimit.indexOf(0) === -1) {
            this.objectForm.commitAddressLimit.push(0)
          }
        }
      }
    },
    dialogClose() {
      this.resetForm()
      this.$emit("close");
    },
    
    cleanImg() {
      this[this.keyType].logo = "";
      this[this.keyType].name = "";
      this[this.keyType].discount = null;
      this[this.keyType].skuId = "";
      this.fileList = []

      // if(this.fileList.length < 1){
      //   this.$refs.upload.$children[1].$el.style.display = "inline-block";
      // }
    },
    dateFormat() {
      let date = new Date();
      let year = date.getFullYear();

      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      this.nowTime =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
    },
    jumpCreation() {
      window.open(
        "https://passport.shop.jd.com/login/index.action?ReturnUrl=https%3A%2F%2Fpromo.shop.jd.com%2Fweb%2Fcoupon%2Fdetail%2Fshop%2F0%3F"
      );
      // let routeUrl = this.$router.resolve({
      //   path: "/integralCenter/prizeCenter/coupon_management",
      // });
      // window.open(routeUrl.href, "_blank");
    },
    jumpSansCreation() {
      this.$router.push({
        name: "coupon_management",
        query: { to: 1 },
      });
    },
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpEkCz() {
      window.open("http://quanyi.shop.jd.com/#/eAccount");
    },
    jumpEk() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 3 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpaqyCz() {
      window.open("https://quanyi.shop.jd.com/#/aiqiyiAccount");
    },
    jumpaqy() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 4 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpPlusCz() {
      window.open("https://quanyi.shop.jd.com/#/plusAccount");
    },
    jumpPlus() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 5 },
      });
      window.open(routeUrl.href, "_blank");
    },
    jumpRedCz() {
      window.open("https://quanyi.shop.jd.com/#/redGiftAccount");
    },
    jumpRed() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/assetManagement",
        query: { tabAct: 6 },
      });
      window.open(routeUrl.href, "_blank");
    },
    //获取店铺商品
    getShopList() {
      // this.formShopList;
      getTaobaoItemListSku(this.formShopList).then((res) => {
        this.tableShopData = res.data.records;
        this.totalListThr = Number(res.data.total);
      });
    },

    getSeller() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);

        this.getTrees(data);

        // debugger
        let list = data.filter((item) => item.parent_id == 0);
        // console.log('list',list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        // console.dir(cascaderArr);

        // this.commodityList[0].options = cascaderArr;
        this.cascaderList = cascaderArr;
      });
      // this.$nextTick(() => {
      //   this.$refs.inputForm.formSearch();
      // });
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    //实物选择
    chooseShop(val) {
      console.log('实物奖品选择：',val);
      const skuIds = [val.skuId];
      this.sureLoading = true;
      checkProduct(skuIds)
        .then((res) => {
          this.sureLoading = false;
          if (res.code == 1) {
            if (res.data.isHave) {
              this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
            } else {
              this[this.keyType].logo = val.logo;
              this[this.keyType].logo = val.logo;
              this[this.keyType].name = this.isATwoPrice
                ? val.skuName.substr(0, 20)
                : val.skuName.substr(0, 12);
              this[this.keyType].discount = val.jdPrice;
              this[this.keyType].skuId = val.skuId;
              this[this.keyType].wareId = this.venderType ? val.skuId : val.wareId;
              this.dialogFormVisible = false;
            }
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.sureLoading = false;
        });
      // this.objectForm.logo = val.logo;
      // this.objectForm.name = this.isATwoPrice
      //   ? val.skuName.substr(0, 20)
      //   : val.skuName.substr(0, 12);
      // this.objectForm.discount = val.jdPrice;
      // this.objectForm.skuId = val.skuId;
      // this.objectForm.wareId = this.venderType ? val.skuId : val.wareId;
      // this.dialogFormVisible = false;
    },
    searchContent(val) {
      this.formShopList.size = 5;
      this.formShopList.current = 1;
      if (val.categoryId) {
        this.formShopList.categoryId = val.categoryId.join(",");
      } else {
        this.formShopList.categoryId = "";
      }
      this.formShopList.skuId = val.skuId;
      this.formShopList.skuStatus = val.skuStatus;
      this.formShopList.skuName = val.skuName;
      this.getShopList();
    },
    //获取优惠券
    quireList() {
      this.dateFormat();
      // this.formList.beginTime = this.nowTime;
      couponList(this.formList).then((res) => {
        this.tableLoading = false;
        this.internalTable = res.data.records;
        this.internalTable.forEach((item) => {
          // item.couponType = 1;  //Note----bug修改
        });
        this.totalNum = Number(res.data.total);
      });
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      console.log("===>", this.tableLoading);
      querySellerCouponExternalList(this.formListTwo)
        .then((res) => {
          this.tableLoading = false;
          console.log("===>", this.tableLoading);
          this.externalTable = res.data.records;
          this.externalTable.forEach((item) => {
            item.couponId = Number(item.id);
          });
          this.totalNumTwo = Number(res.data.total);
        })
        .catch((res) => {
          this.tableLoading = false;
        });
    },
    //输入框限制负数
    checkputn(e) {
      let filtered = e.replace(/^0|[^\d]/g, "");
     let newVal = Number(filtered);
      // //下边写用户输入时需要的执行逻辑
      // if(this.ruleForm.inputprize!= filtered) {
      //     this.ruleForm.inputprize = filtered
      // }
      // 不能输入0，绑定的值如果小于1，那么输入框置空
      if (newVal < 1) {
        newVal = "";
      } else if (newVal > 99999999) {
        newVal= 99999999;
      }
      return newVal
    },
    limitInput(event) {
        // 支持输入小数点后两位
        let val = event.target.value;
        // 仅保留数字和小数点
        val = val.replace(/[^\d.]/g, "");
        // 只保留第一个小数点，去除多余的小数点
        val = val.replace(/\./, "#DOT#").replace(/\./g, "").replace(/#DOT#/, ".");
        // 限制小数点后最多两位
        val = val.replace(/(\.\d{2}).*/, "$1");
        // 整数部分去除开头多余的 0（如 01 -> 1，00.5 -> 0.5）
        val = val.replace(/^0+(\d)/, "$1");
        // 以小数点开头时自动补 0（如 .5 -> 0.5）
        val = val.replace(/^\./, "0.");
        // 不允许输入 0
        if (this.objectForm.resource == 3) {
          this.physicalForm.discount = val;
        }
        if(this.objectForm.discount) {
          this.objectForm.discount = val;
        }
        if(this.withOrderForm.discount) {
          this.withOrderForm.discount = val;
        }
    },
    inputLimitZero(val) {
      if(Number(val.target.value)==0) {
        // 不允许输入 0
        this.$message.warning("请输入大于0的数字");
        return "";
      }else {
        return val.target.value;
      }
    },
    change(b) {
      let a = {};
      this.eKselectList.forEach((item) => {
        if (item.id == b) {
          a = item;
        }
      });
      // 原剩余份额
      this.ekForm.quantityBalance = a.quantityBalance;
      this.aqyForm.quantityBalance = a.quantityBalance;
      this.plusForm.quantityBalance = a.quantityBalance;
      // V2.5新增剩余份额
      this.ekForm.budgetRemain = a.budgetRemain;
      this.aqyForm.budgetRemain = a.budgetRemain;
      this.plusForm.budgetRemain = a.budgetRemain;
      // 单份奖品数量
      this.ekForm.num = 1;
      this.aqyForm.num = 1;
      this.plusForm.num = 1;
      console.log(this.ekForm);
    },
    change1(b) {
      let a = {};
      this.redSelectList.forEach((item) => {
        if (item.id == b) {
          a = item;
        }
      });
      this.redForm.quantityBalance = a.quantityTotal
        ? a.quantityTotal - a.quantityActual
        : ""; // 原剩余份额
      this.redForm.budgetRemain = a.budgetRemain; // V2.5新增剩余份额
      this.redForm.num = a.quantityAmount
        ? a.quantityAmount / a.quantityTotal
        : ""; // 单份奖品数量
    },
    //选择奖品弹窗
    openDialog() {
      this.dialogVisibleFrom = true;
      this.getJingdouList();
    },
    //查询京豆
    getJingdouList() {
      console.log(
        "父ItemArr:",
        this.$parent.itemArr,
        "父echoData:",
        this.$parent.echoDate
      );
      let arr = [];
      let params = this.venderType
        ? { accountCode: this.formAccount.accountCode }
        : {};
      if (this.$parent.activityData) {
        if (this.$parent.activityData.id == 36) {
          // 打榜有礼特殊处理
          this.$parent.editableTabs.forEach((tabs) => {
            tabs.content.forEach((item) => {
              if (item.prizeType == 2) {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  arr.push(item.assetsId);
                }
              }
            });
          });
        } else if (
          this.$parent.activityData.id != 4 &&
          this.$parent.activityData.id != 5
        ) {
          // 过滤出京豆计划ID
          this.$parent.itemArr.forEach((item) => {
            if (item.prizeType == 2) {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                arr.push(item.assetsId);
              }
            }
          });
          if (this.$parent.awardSettingsLsit) {
            console.log(
              this.$parent.awardSettingsLsit,
              "this.$parent.awardSettingsLsit===>"
            );
            this.$parent.awardSettingsLsit.forEach((item) => {
              if (item.prizeType == 2) {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  arr.push(item.assetsId);
                }
              }
            });
          }
        } else {
          // 邀请关注和邀请开卡有三种奖品类型，分开处理
          // 奖品类型 0统一(awardSettingsLsit) 1梯度(itemArr) 2任务(taskTableData)
          console.log(
            this.$parent.ruleForm.isCumulativePrize,
            "this.$parent.ruleForm.isCumulativePrize===》"
          );
          console.log(this.$parent.taskTableData, "taskTableData===》");
          console.log(this.$parent.awardSettingsLsit, "awardSettingsLsit===》");
          console.log(this.$parent.itemArr, "itemArr===》");
          if (this.$parent.ruleForm.isCumulativePrize == 0) {
            if (this.$parent.awardSettingsLsit) {
              this.$parent.awardSettingsLsit.forEach((item) => {
                if (item.prizeType == 2) {
                  if (item.assetsId != this.$parent.echoDate.assetsId) {
                    arr.push(item.assetsId);
                  }
                }
              });
            }
          } else if (this.$parent.ruleForm.isCumulativePrize == 1) {
            this.$parent.itemArr.forEach((item) => {
              if (item.prizeType == 2) {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  arr.push(item.assetsId);
                }
              }
            });
          } else if (this.$parent.ruleForm.isCumulativePrize == 2) {
            this.$parent.taskTableData.forEach((item) => {
              if (item.prizeType == 2) {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  arr.push(item.assetsId);
                }
              }
            });
          }
        }
      }
      jingdouList({
        ...this.formLitJD,
        activityId: this.actId ? this.actId.id : "",
        idList: arr,
        ...params,
      })
        .then((res) => {
          let selectArr = res.data.records.map((item) => {
            return {
              ...item,
              label: item.planName,
              value: item.id,
              sendTimes: item.sendTimes,
              budgetRemain: item.budgetRemain, // 金豆计划剩余数量
            };
          });
          this.selectList = selectArr;
          this.planList.jingdou = res.data.records;
          if (this.dialogVisibleFrom) {
            let selected = this.selectList.find(
              (item) => item.value == this.echoDate.assetsId
            );
            this.activeSendtimes = selected.sendTimes;
          }
        })
        .catch((res) => {});
    },
    //京豆
    getJingdouData() {
      console.log("this.jingduoForm", this.jingduoForm);
      this.jingdouData = {
        couponId: this.jingduoForm.region.value,
        discount: Number(this.jingduoForm.count),
        name: this.jingduoForm.region.label,
        singleAmount: Number(this.jingduoForm.count),
        cycleType: this.jingduoForm.cycleType,
        bindPlanList: this.jingduoForm.bindPlanList,
      };
    },
    setJingdouData() {
      let jingdouPlanList = this.planList.jingdou;
      let item = jingdouPlanList.find((i) => {
        return i.id == this.jingdouData.couponId;
      });
      if(this.jingdouData.cycleType==0) {
        if(!this.jingduoForm.count&&!this.jingdouData.couponId) {
          this.$message.error("请完善京豆计划信息！");
          return;
        }
        if (this.num == 2) {
          if (item) {
            // 梯度奖励
            if (this.$parent.ruleForm.isCumulativePrize) {
              let line =
                this.$parent.ruleForm.isCumulativePrize == 1
                  ? this.$parent.tableData[this.$parent.tableIndex]
                  : this.$parent.taskTableData[this.$parent.taskTableIndex];
              if (
                this.jingdouData.singleAmount &&
                line.prizeCount &&
                Number(this.jingdouData.singleAmount) * Number(line.prizeCount) >
                  Number(item.quantityTotal)
              ) {
                this.$message.error("京豆发放数量不能大于该京豆预算额！");
                return;
              }
              if (
                this.jingdouData.singleAmount &&
                Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
              ) {
                this.$message.error("单份奖励个数不能大于该京豆预算额！");
                return;
              }
              if (!this.jingdouData.singleAmount) {
                this.$message.error("请填写京豆单份奖励个数！");
                return;
              }
            } else {
              if (
                !this.$parent.ruleForm.peopleCount ||
                Number(this.$parent.ruleForm.peopleCount) > 20
              ) {
                this.$message.warning(
                  "京豆奖励需先填写最多邀请人数规则，且数目不可大于20人"
                );
                return;
              } else if (
                Number(this.$parent.ruleForm.peopleCount) > item.sendTimes
              ) {
                this.$message.error(
                  "奖品发放规则与京豆计划的发豆规则不一致，会导致奖品发放失败，请重新选择京豆计划～"
                );
                return;
              }
              if (
                Number(this.$parent.ruleForm.prizeCount) &&
                this.jingdouData.singleAmount &&
                Number(this.$parent.ruleForm.prizeCount) *
                  Number(this.jingdouData.singleAmount) >
                  Number(item.quantityTotal)
              ) {
                this.$message.error("京豆发放数量不能大于该京豆预算额！");
                return;
              }
              if (
                this.jingdouData.singleAmount &&
                Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
              ) {
                this.$message.error("单份奖励个数不能大于该京豆预算额！");
                return;
              }
              if (!this.jingdouData.singleAmount) {
                this.$message.error("请填写京豆单份奖励个数！");
                return;
              }
            }
          }
        } else {
          let line = this.JingdouCount;
          if (item) {
            if (
              line.prizeCount &&
              this.jingdouData.singleAmount &&
              Number(line.prizeCount) * Number(this.jingdouData.singleAmount) >
                Number(item.quantityTotal)
            ) {
              this.$message.error("京豆发放数量不能大于该京豆预算额！");
              return;
            }
            if (
              this.jingdouData.singleAmount &&
              Number(this.jingdouData.singleAmount) > Number(item.quantityTotal)
            ) {
              this.$message.error("单份奖励个数不能大于该京豆预算额！");
              return;
            }
            if (!this.jingdouData.singleAmount) {
              this.$message.error("请填写京豆单份奖励个数！");
              return;
            }
          }
        }
      } else {
        const bindPlanList = this.jingduoForm.bindPlanList;
        const flag = bindPlanList.some((item)=>!item.id)
        if(flag) {
          this.$message.error("请选择京豆计划！");
          return;
        }
        const flag1 = bindPlanList.some((item)=>!item.singleAmount)
        if(flag1) {
          this.$message.error("单份奖励个数不可为空");
          return;
        }
        const flag2 = bindPlanList.some((item)=>!item.totalAmount)
        if(flag2) {
          this.$message.error("奖品数量不可为空");
          return;
        }
        const flag3 = bindPlanList.some((item)=>!item.useEndTime||!item.useStartTime)
        if(flag3) {
          this.$message.error("使用计划时间不可为空");
          return;
        }
        // 校验使用计划时间在京豆计划本身时间范围内
        for (let i = 0; i < bindPlanList.length; i++) {
          const plan = bindPlanList[i];
          if (plan.useStartTime && plan.startTime) {
            if (new Date(plan.useStartTime) < new Date(plan.startTime)) {
              this.$message.error("使用计划时间请在京豆计划范围内");
              return;
            }
          }
          if (plan.useEndTime && plan.endTime) {
            if (new Date(plan.useEndTime) > new Date(plan.endTime)) {
              this.$message.error("使用计划时间请在京豆计划范围内");
              return;
            }
          }
        }
        for (let i = 1; i < bindPlanList.length; i++) {
          const prevPlan = bindPlanList[i - 1];
          const currentPlan = bindPlanList[i];
          if (prevPlan.useEndTime && currentPlan.useEndTime) {
            if (new Date(currentPlan.useEndTime) <= new Date(prevPlan.useEndTime)) {
              this.$message.error("排序靠后的京豆计划使用结束时间需晚于靠前的计划的使用结束时间");
              return;
            }
          }
        }
        // 校验最后一个京豆计划的结束时间需晚于活动结束时间
        const lastPlan = bindPlanList[bindPlanList.length - 1];
        if (lastPlan.useEndTime && this.actEndTime) {
          if (new Date(lastPlan.useEndTime) < new Date(this.actEndTime)) {
            this.$message.error("最后一个京豆计划的结束时间需晚于活动结束时间");
            return;
          }
        }
        // 校验每个计划单份奖励数量*奖品数量不超过剩余京豆预算
        for (let i = 0; i < bindPlanList.length; i++) {
          const plan = bindPlanList[i];
          if (plan.singleAmount && plan.totalAmount && plan.budgetRemain) {
            const totalBeans = Number(plan.singleAmount) * Number(plan.totalAmount);
            if (totalBeans > Number(plan.budgetRemain)) {
              // 查找计划名称
              const planInfo = this.selectList.find(item => item.id === plan.id);
              const planName = planInfo ? planInfo.label : `第${i+1}个计划`;
              this.$message.error(`${planName}剩余数量不足`);
              return;
            }
          }
        }
        // 校验每个京豆计划的开始时间要在活动时间范围内
        for (let i = 0; i < bindPlanList.length; i++) {
          const plan = bindPlanList[i];
          if (plan.startTime && this.actEndTime) {
            if (new Date(plan.startTime) > new Date(this.actEndTime)) {
              const planInfo = this.selectList.find(item => item.id === plan.id);
              const planName = planInfo ? planInfo.label : `第${i+1}个计划`;
              this.$message.error(`${planName}京豆计划的开始时间要在活动时间范围内，请重新选择`);
              return;
            }
          }
        }
      }
      // a2定制取消限制
      // if (
      //   this.jingdouData.singleAmount &&
      //   Math.ceil(this.jingdouData.singleAmount / 1000) >
      //     Number(this.activeSendtimes) &&
      //   !this.isATwoPrice
      // ) {
      //   this.$message.error(
      //     "因官方接口限制，单次发豆数量上限是1000，超过时会分多次发放，为确保发放成功，京豆计划发放次数必大于等于单份奖励个数/1000，请重新选择京豆计划或者调整单份奖励个数"
      //   );
      //   return;
      // }
      // return
      this.dialogVisibleFrom = false;
      // this.jingdouData.couponId()
      // A2定制传介绍字段
      if (this.isATwoPrice) {
        this.$emit(
          "choose-shop",
          {
            ...this.jingdouData,
            quantityTotal: item.quantityTotal,
            name: `${this.jingdouData.discount}京豆`,
            budgetRemain: item.budgetRemain,
            introduceToUser: this.jingduoForm.introduceToUser,
          },
          2
        );
      } else {
        if(this.jingdouData.cycleType==0){
          this.$emit(
            "choose-shop",
            {
              ...this.jingdouData,
              logo: this.secondLogo,
              quantityTotal: item ? item.quantityTotal : 0,
              name: `${this.jingdouData.discount}京豆`,
              budgetRemain: item ? item.budgetRemain : 0,
            },
            2
          );
        } else if(this.jingdouData.cycleType==1){
          const obj = jingdouPlanList.find((i) => {
            return i.id == this.jingdouData.bindPlanList[0].id
          });
          this.$emit(
            "choose-shop",
            {
              ...this.jingdouData,
              logo: this.secondLogo,
              quantityTotal: obj.quantityTotal,
              name: `${this.jingdouData.bindPlanList[0].singleAmount}京豆`,
              budgetRemain: this.jingdouData.bindPlanList[0].budgetRemain,
              totalAmount: this.jingdouData.bindPlanList[0].totalAmount,
              discount: this.jingdouData.bindPlanList[0].singleAmount,
            },
            2
          );
        }
      }
    },
    //查询京东E卡,爱奇艺会员,京豆PLUS会员
    async acquireAssets() {
      let res = await allAccountList({
        ...this.formLitZC,
        activityId: this.actId ? this.actId.id : "",
      });
      let selectArr = res.data.records.map((item) => {
        return {
          ...item,
          label: item.planName,
        };
      });
      // let selectArr = [
      //   {budgetRemain:9,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:9,id:'148',itemId:5},
      //   {budgetRemain:11,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:11,id:'149',itemId:5},
      //   {budgetRemain:12,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:12,id:'147',itemId:5},
      //   {budgetRemain:13,label:"京东E卡50元14",planName:"京东E卡50元14",quantityBalance:13,id:'146',itemId:5},
      // ]
      // 获取当前活动已使用计划的ID
      let arr5 = [],
        arr6 = [],
        arr7 = [];
      if (this.$parent.activityData) {
        if (this.$parent.activityData.id == 36) {
          // 打榜有礼特殊处理
          this.$parent.editableTabs.forEach((tabs) => {
            tabs.content.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 5) arr5.push(item.assetsId);
                if (item.prizeType == 6) arr6.push(item.assetsId);
                if (item.prizeType == 7) arr7.push(item.assetsId);
              }
            });
          });
        } else if (
          this.$parent.activityData.id != 4 &&
          this.$parent.activityData.id != 5
        ) {
          this.$parent.itemArr.forEach((item) => {
            if (item.assetsId != this.$parent.echoDate.assetsId) {
              if (item.prizeType == 5) arr5.push(item.assetsId);
              if (item.prizeType == 6) arr6.push(item.assetsId);
              if (item.prizeType == 7) arr7.push(item.assetsId);
            }
          });
          if (this.$parent.awardSettingsLsit) {
            this.$parent.awardSettingsLsit.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 5) arr5.push(item.assetsId);
                if (item.prizeType == 6) arr6.push(item.assetsId);
                if (item.prizeType == 7) arr7.push(item.assetsId);
              }
            });
          }
        } else {
          // 邀请关注和邀请开卡有三种奖品类型，分开处理
          if (this.$parent.ruleForm.isCumulativePrize == 0) {
            if (this.$parent.awardSettingsLsit) {
              this.$parent.awardSettingsLsit.forEach((item) => {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  if (item.prizeType == 5) arr5.push(item.assetsId);
                  if (item.prizeType == 6) arr6.push(item.assetsId);
                  if (item.prizeType == 7) arr7.push(item.assetsId);
                }
              });
            }
          } else if (this.$parent.ruleForm.isCumulativePrize == 1) {
            this.$parent.itemArr.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 5) arr5.push(item.assetsId);
                if (item.prizeType == 6) arr6.push(item.assetsId);
                if (item.prizeType == 7) arr7.push(item.assetsId);
              }
            });
          } else if (this.$parent.ruleForm.isCumulativePrize == 2) {
            this.$parent.taskTableData.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 5) arr5.push(item.assetsId);
                if (item.prizeType == 6) arr6.push(item.assetsId);
                if (item.prizeType == 7) arr7.push(item.assetsId);
              }
            });
          }
        }
      }
      console.log("arr5,arr6,arr7", arr5, arr6, arr7);
      // 过滤出当前活动未使用的计划
      if (this.formLitZC.assetType == 5) {
        // 京东E卡
        selectArr = selectArr.filter((item) => !arr5.includes(Number(item.id)));
      } else if (this.formLitZC.assetType == 6) {
        // 爱奇艺会员
        selectArr = selectArr.filter((item) => !arr6.includes(Number(item.id)));
      } else if (this.formLitZC.assetType == 7) {
        // 京东plus
        selectArr = selectArr.filter((item) => !arr7.includes(Number(item.id)));
      }
      console.log(selectArr);
      this.eKselectList = selectArr;
    },
    //查询红包
    async redBag() {
      let res = await redPacketList({
        ...this.formLitRed,
        activityId: this.actId ? this.actId.id : "",
      });
      let selectArr = res.data.records.map((item) => {
        return {
          ...item,
          label: item.planName,
        };
      });
      // let selectArr = [
      //   {budgetRemain:9,label:"京东E卡50元14",quantityAmount:100,quantityTotal:20,id:'148'},
      //   {budgetRemain:11,label:"京东E卡50元14",quantityAmount:20,quantityTotal:10,id:'149'},
      //   {budgetRemain:12,label:"京东E卡50元14",quantityAmount:50,quantityTotal:5,id:'147'},
      //   {budgetRemain:13,label:"京东E卡50元14",quantityAmount:10,quantityTotal:2,id:'146'},
      // ]
      let arr = [];
      if (this.$parent.activityData) {
        if (
          this.$parent.activityData.id != 4 &&
          this.$parent.activityData.id != 5
        ) {
          this.$parent.itemArr.forEach((item) => {
            if (item.assetsId != this.$parent.echoDate.assetsId) {
              if (item.prizeType == 8) arr.push(item.assetsId);
            }
          });
          if (this.$parent.awardSettingsLsit) {
            this.$parent.awardSettingsLsit.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 8) arr.push(item.assetsId);
              }
            });
          }
        } else {
          // 邀请关注和邀请开卡有三种奖品类型，分开处理
          if (this.$parent.ruleForm.isCumulativePrize == 0) {
            if (this.$parent.awardSettingsLsit) {
              this.$parent.awardSettingsLsit.forEach((item) => {
                if (item.assetsId != this.$parent.echoDate.assetsId) {
                  if (item.prizeType == 8) arr.push(item.assetsId);
                }
              });
            }
          } else if (this.$parent.ruleForm.isCumulativePrize == 1) {
            this.$parent.itemArr.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 8) arr.push(item.assetsId);
              }
            });
          } else if (this.$parent.ruleForm.isCumulativePrize == 2) {
            this.$parent.taskTableData.forEach((item) => {
              if (item.assetsId != this.$parent.echoDate.assetsId) {
                if (item.prizeType == 8) arr.push(item.assetsId);
              }
            });
          }
        }
      }
      console.log("arr", arr);
      // 过滤出当前活动未使用的计划
      this.redSelectList = selectArr.filter(
        (item) => !arr.includes(Number(item.id))
      );
    },
    async handleClick(tab, event) {
      if (tab.name == "first") {
        this.formLitZC.assetType = 1;
        this.prizeGoShop.goShopSetting = 0
        this.prizeGoShop.goShopAppId = ""
        this.prizeGoShop.goShopUrl = ""
      }
      if (tab.name == "second") {
        this.formLitZC.assetType = 2;
        this.jingduoForm.count = ""; //京豆
        this.jingduoForm.bindPlanList = [
            {
            id: "", //京豆计划
            startTime: "", //计划开始时间
            endTime: "", //计划结束时间
            sendBeanType: 0, //单次发放京东数量类型，0:1~1000 1:1~50000
            useStartTime: "", //使用开始时间
            useEndTime: "", //使用结束时间
            singleAmount: "", //单份奖励数量
            totalAmount: "", //总共奖品数量 -1表示无限制
            sendTimes: "", //发豆次数
            budgetRemain: "", //剩余京豆预算
          }
        ];
        this.jingduoForm.cycleType = 0;
      }
      if (tab.name == "third") {
        this.formLitZC.assetType = 3; //实物
        this.objectForm.resource = "1";
        this.objectForm.name = "";
        this.objectForm.discount = "";
        this.objectForm.logo = "";

        this.physicalForm.region = "";
        this.physicalForm.budgetRemain = "";
        this.physicalForm.discount = "";
        this.physicalForm.logo = "";
        this.physicalForm.name = "";
        this.physicalForm.inventoryType = "";
        await this.getPhysical();
      }
      if (tab.name == "four") {
        this.formLitZC.assetType = 4; //店铺积分
        this.integralForm.discount = "";
      }
      if (tab.name == "fird") {
        this.formLitZC.assetType = 5; //E卡
        this.ekForm.region = "";
        this.ekForm.quantityBalance = "";
        this.ekForm.budgetRemain = "";
        this.ekForm.num = "";
        this.eKselectList = [];
        await this.acquireAssets();
      } else if (tab.name == "six") {
        this.formLitZC.assetType = 6; //爱奇艺会员
        this.aqyForm.region = "";
        this.aqyForm.quantityBalance = "";
        this.aqyForm.budgetRemain = "";
        this.aqyForm.num = "";
        this.eKselectList = [];
        await this.acquireAssets();
      } else if (tab.name == "sev") {
        this.formLitZC.assetType = 7; //PLUS会员
        this.plusForm.region = "";
        this.plusForm.quantityBalance = "";
        this.plusForm.budgetRemain = "";
        this.plusForm.num = "";
        this.eKselectList = [];
        await this.acquireAssets();
      }
      if (tab.name == "eig") {
        this.formLitZC.assetType = 8; //现金红包
        this.redForm.region = "";
        this.redForm.budgetRemain = "";
        this.redForm.num = "";
        this.redSelectList = [];
        await this.redBag();
      }
      if (tab.name == "nine") {
        this.formLitZC.assetType = 10; //礼品卡
        this.giftCardForm.region = "";
        this.giftCardForm.logo = "";
        this.giftCardForm.budgetRemain = "";
        this.giftCardForm.num = "";
        await this.getGiftCardList();
        this.isShowGift = true;
      }
      // if (tab.name == "ten") {
      //   this.formLitZC.assetType = 3; //实物（实物管理）
      //   this.physicalForm.region = "";
      //   this.physicalForm.budgetRemain = "";
      //   this.physicalForm.discount = "";
      //   this.physicalForm.logo = "";
      //   this.physicalForm.name = "";
      //   this.physicalForm.inventoryType = "";
      //   // A2定制
      //   if (this.isATwoPrice) {
      //     this.physicalForm.introducePicUrl = [];
      //     this.physicalForm.introduceToUser = "";
      //     this.physicalForm.cost = "";
      //     this.physicalForm.manufacturer = "";
      //     this.physicalForm.introduce = "";
      //   }
      //   await this.getPhysical();
      // }
      // 专享价
      if (tab.name == "eleven") {
        this.formLitZC.assetType = 12; //专享价
        this.exclusivePriceForm.name = "";
        this.exclusivePriceForm.logo = this.elevenLogo;
        this.exclusivePriceForm.couponId = "";
        this.exclusivePriceForm.discount = "";
        this.exclusivePriceForm.reducePrice = ""
        this.actData = [];
      }
      // 令牌
      if (tab.name == "twelve") {
        this.formLitZC.assetType = 13; //令牌
        this.tokenForm.name = "";
        this.tokenForm.logo = this.twelveLogo;
        this.tokenForm.couponId = "";
        this.tokenForm.discount = 0;
        this.tokenData = [];
      }
      // 实物奖品（随单发）
      if (tab.name == "thirteen") {
        this.formLitZC.assetType = 3; //实物
        this.objectForm.resource = "1";
        this.objectForm.name = "";
        this.objectForm.discount = "";
        this.objectForm.logo = "";

        this.physicalForm.region = "";
        this.physicalForm.budgetRemain = "";
        this.physicalForm.discount = "";
        this.physicalForm.logo = "";
        this.physicalForm.name = "";
        this.physicalForm.inventoryType = "";
        this.withOrderForm.pointActivityPrizeRemark = {
          content: "",
          remarkActionType: 2,
          startOrderTime: "",
          endOrderTime: "",
          receivePayment: "",
          skuMatchType: 0,
          tradeLimitTime: "",
          tradeLimitTimeUnit: 2,
          skuIds: "",
          // loseEfficacyRemark: "",
        }
        await this.getPhysical();
      }
    },
    handleClickTwo(tab, event) {
      if (tab.name == "second") {
        this.querySellerCouponExternal();
      } else {
        // console.log(222);
      }
    },
    searchForm(val) {
      this.formList.type = val.type;
      this.formList.display = val.display;
      this.formList.grantType = val.grantType;
      this.quireList();
    },
    searchFormTwo(val) {
      this.formListTwo.name = val.name;
      this.formListTwo.discount = val.discount;
      this.formListTwo.issueType = val.issueType;
      this.querySellerCouponExternal();
    },
    chooseTab(val) {
      const obj = {...val}
      obj.singleAmount = obj.numPerSending;
      obj.name = obj.numPerSending + "张" + obj.discount + "元优惠券";
      obj.id = obj.assetsId;
      obj.couponId = obj.assetsId
      this.couponObj = {...obj}
      this.selectedCouponId = obj.assetsId;
      this.$message.success("优惠券选择成功")
      // this.$emit("choose-shop", val, 1);
    },
    storePoint() {
      this.integralForm.singleAmount = this.integralForm.discount;
      this.$emit(
        "choose-shop",
        { ...this.integralForm, logo: this.fourLogo },
        4
      );
    },
    jingDonData() {
      if (this.formLitZC.assetType == 5) {
        let obj = {};
        this.eKselectList.forEach((item) => {
          if (item.id == this.ekForm.region) {
            obj = item;
          }
        });
        //E卡
        this.zcData = {
          couponId: this.ekForm.region,
          discount: parseFloat(obj.quota),
          name: this.nameStr(1, obj.itemId),
          budgetRemain: obj.budgetRemain,
          singleAmount: 1,
          logo: this.firdLogo,
        };
        if (this.isATwoPrice) {
          this.zcData = {
            ...this.zcData,
            introduceToUser: this.ekForm.introduceToUser,
          };
        }
      } else if (this.formLitZC.assetType == 6) {
        let obj = {};
        this.eKselectList.forEach((item) => {
          if (item.id == this.aqyForm.region) {
            obj = item;
          }
        });
        console.log(this.eKselectList);
        console.log(obj, this.aqyForm.region, 6666);
        //爱奇艺会员
        this.zcData = {
          couponId: this.aqyForm.region,
          discount: obj.quota,
          name: this.nameStr(3, obj.itemId),
          budgetRemain: obj.budgetRemain,
          singleAmount: 1,
          logo: this.sixLogo,
        };
      } else if (this.formLitZC.assetType == 7) {
        let obj = {};
        this.eKselectList.forEach((item) => {
          if (item.id == this.plusForm.region) {
            obj = item;
          }
        });
        //PLUS会员
        this.zcData = {
          couponId: this.plusForm.region,
          discount: obj.quota,
          name: this.nameStr(2, obj.itemId),
          budgetRemain: obj.budgetRemain,
          singleAmount: 1,
          logo: this.sevLogo,
        };
      }
      // console.log(this.zcData, 222);
    },
    // 现金红包设置
    redData() {
      let obj = {};
      this.redSelectList.forEach((item) => {
        if (item.id == this.redForm.region) {
          obj = item;
        }
      });

      this.zcData = {
        couponId: this.redForm.region,
        discount: this.redForm.num,
        name: obj.label,
        singleAmount: 1,
        budgetRemain: obj.budgetRemain,
        logo: this.eigLogo,
      };
    },
    // 礼品卡设置
    handleGetGiftCard(row) {
      let obj = {};
      this.giftCardList.some((item) => {
        if (item.id == row.region) {
          obj = item;
        }
      });
      this.zcData = {
        couponId: row.region,
        discount: row.num,
        singleAmount: 1,
        name: row.name,
        logo: this.nineLogo,
        budgetRemain: row.budgetRemain,
      };
      this.isShowGift = false;
      this.jingDonEka(10);
    },
    changeJP() {
      this.zcData = {
        giftType: this.objectForm.resource,
        logo: this.objectForm.logo,
        couponId: this.objectForm.wareId,
        discount: this.objectForm.discount,
        name: this.objectForm.name,
        singleAmount: 1,
        skuId: this.objectForm.skuId,
        isFollowActivityEndTime: this.objectForm.isFollowActivityEndTime,
        addressFillEndTime: this.objectForm.addressFillEndTime,
        predictSendTime: this.objectForm.predictSendTime,
        addressFillLimit: this.objectForm.addressFillLimit,
        // 数组转逗号分隔字符串提交
        commitAddressLimit: this.objectForm.commitAddressLimit.join(','),
      };
      // if(this.zcData.addressFillEndTime == ''){
      //   this.zcData.isFollowActivityEndTime = 1
      // }
      if (this.objectForm.resource == 2) {
        delete this.zcData.skuId;
        delete this.zcData.couponId;
      }
      console.log(this.zcData, 6666);
      //A2定制
      if (this.isATwoPrice) {
        this.zcData = {
          ...this.zcData,
          introduce: this.objectForm.introduce,
          manufacturer: this.objectForm.manufacturer,
          cost: this.objectForm.cost,
          introducePicUrl: this.introducePicUrl,
          introduceToUser: this.objectForm.introduceToUser,
        };
      }
      if(this.attachInfo.shouldCollectExtraData==1) {
        const isHasTitle = this.attachInfo.questions.some((item)=>item.title)
        if(!isHasTitle) {
          this.$message.warning("请设置附加信息")
            return
          }
      }
        this.zcData = {
          ...this.zcData,
          shouldCollectExtraData: this.attachInfo.shouldCollectExtraData,
          extraQuestion: this.attachInfo.shouldCollectExtraData==1 ? this.attachInfo.questions[0] : null
        };
      if(!this.objectForm.logo && this.objectForm.resource!=3){
        if(this.objectForm.resource==1){
          return this.$message.warning("请选择店铺商品");
        }else{
           return this.$message.warning("请上传商品图片");
        }
      }
      this.dialogVisibleFrom = false;
      console.log(this.objectForm, "选择实物");
      this.$emit("choose-shop", this.zcData, 3);
    },
    // 校验
    validateWithOrder() {
      if(!this.withOrderForm.logo && this.withOrderForm.resource!=3){
        if(this.withOrderForm.resource==1){
          this.$message.warning("请选择店铺商品");
          return
        }else{
          this.$message.warning("请上传商品图片");
           return
        }
      }
      if(this.withOrderForm.resource != 3) {
        if(!this.withOrderForm.name) {
          this.$message.warning("请输入奖品名称");
          return
        }
        if(!this.withOrderForm.discount) {
          this.$message.warning("请输入奖品价值");
          return
        }
      } else {
        if(!this.physicalForm.name) {
          this.$message.warning("请选择奖品");
          return
        }
        if(!this.physicalForm.discount) {
          this.$message.warning("请输入奖品价值");
          return
        }
      }
      if(!this.withOrderForm.pointActivityPrizeRemark.content) {
        this.$message.warning("请输入备注内容");
        return
      }
      if(this.withOrderForm.pointActivityPrizeRemark.remarkActionType==1||this.withOrderForm.pointActivityPrizeRemark.remarkActionType==2) {
        if(!this.withOrderForm.pointActivityPrizeRemark.startOrderTime||!this.withOrderForm.pointActivityPrizeRemark.endOrderTime) {
          this.$message.warning("请选择下单时间");
          return
        }
        // 下单开始时间需小于下单结束时间
        if(new Date(this.withOrderForm.pointActivityPrizeRemark.startOrderTime).valueOf() > new Date(this.withOrderForm.pointActivityPrizeRemark.endOrderTime).valueOf()) {
          this.$message.warning("下单开始时间需小于下单结束时间")
          return
        }
        // 下单结束时间需小于活动结束时间
        if(new Date(this.withOrderForm.pointActivityPrizeRemark.endOrderTime).valueOf() > new Date(this.actEndTime).valueOf()) {
          this.$message.warning("下单结束时间需小于活动结束时间")
          return
        }
      } else {
        if(!this.withOrderForm.pointActivityPrizeRemark.tradeLimitTime) {
          this.$message.warning("请输入下单时间");
          return
        }
      }
      if(!this.withOrderForm.pointActivityPrizeRemark.receivePayment) {
        this.$message.warning("请输入订单金额");
        return
      }
      if(this.withOrderForm.pointActivityPrizeRemark.skuMatchType!=0&&this.excludeOrSpecifyList.length==0) {
        this.$message.warning(`请选择${this.withOrderForm.pointActivityPrizeRemark.skuMatchType==1?"指定":"排除"}商品`);
        return
      }

      // if(!this.withOrderForm.pointActivityPrizeRemark.loseEfficacyRemark) {
      //   this.$message.warning("请输入奖品失效备注");
      //   return
      // }
      return true;
    },
    changeWithOrder() {
      if(!this.validateWithOrder()) return
      this.zcData = {
        giftType: this.withOrderForm.resource,
        logo: this.withOrderForm.logo,
        couponId: this.withOrderForm.wareId,
        discount: this.withOrderForm.discount,
        name: this.withOrderForm.name,
        singleAmount: 1,
        skuId: this.withOrderForm.skuId,
        pointActivityPrizeRemark: this.withOrderForm.pointActivityPrizeRemark,
      };
      if (this.withOrderForm.resource == 2) {
        delete this.zcData.skuId;
        delete this.zcData.couponId;
      }
      this.dialogVisibleFrom = false;
      this.$emit("choose-shop", this.zcData, 14);
    },
    resetPhysical() {
      this.getPhysical();
    },
    createPhysical() {
      let routeUrl = this.$router.resolve({
        path: "/tool/prizeCenter/goodsManagement",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 实物（实物管理）获取剩余份数
    handleChangePhysical(id) {
      let obj = this.physicalList.find((item) => item.id == id);
      this.physicalForm.region = obj.id;
      this.physicalForm.logo = obj.image;
      this.physicalForm.name = obj.goodsName;
      this.physicalForm.budgetRemain =
        obj.inventoryType == 1 ? "" : obj.budgetRemain;
      this.physicalForm.inventoryType = obj.inventoryType;
    },
    changePhysical() {
      this.zcData = {
        logo: this.physicalForm.logo,
        discount: this.physicalForm.discount,
        name: this.physicalForm.name,
        couponId: this.physicalForm.region,
        isGoodManage: 1,
        singleAmount: 1,
        giftType: "1",
        budgetRemain:
          this.physicalForm.inventoryType == 1
            ? ""
            : this.physicalForm.budgetRemain,
        isFollowActivityEndTime: this.objectForm.isFollowActivityEndTime,
        addressFillEndTime: this.objectForm.addressFillEndTime,
        predictSendTime: this.objectForm.predictSendTime,
        addressFillLimit: this.objectForm.addressFillLimit,
        // 数组转逗号分隔字符串提交
        commitAddressLimit: this.objectForm.commitAddressLimit.join(','),
      };
      // if(this.zcData.addressFillEndTime == ''){
      //   this.zcData.isFollowActivityEndTime = 1
      // }
      if (this.isATwoPrice) {
        // A2定制
        (this.zcData.introducePicUrl = this.physicalForm.introducePicUrl || []),
          (this.zcData.introduce = this.physicalForm.introduce),
          (this.zcData.introduceToUser = this.physicalForm.introduceToUser),
          (this.zcData.manufacturer = this.physicalForm.manufacturer),
          (this.zcData.cost = this.physicalForm.cost);
      }
      if(this.attachInfo.shouldCollectExtraData==1) {
        const isHasTitle = this.attachInfo.questions.some((item)=>item.title)
        if(!isHasTitle) {
          this.$message.warning("请设置附加信息")
            return
          }
      }
      this.zcData = {
        ...this.zcData,
        shouldCollectExtraData: this.attachInfo.shouldCollectExtraData,
        extraQuestion: this.attachInfo.shouldCollectExtraData==1 ? this.attachInfo.questions[0] : null
      };
      this.dialogVisibleFrom = false;
      this.jingDonEka(3, 1);
      // this.$emit("choose-shop", this.zcData, 3);
    },
    changePhysicalWithOrder() {
      if(!this.validateWithOrder()) return
      this.zcData = {
        logo: this.physicalForm.logo,
        discount: this.physicalForm.discount,
        name: this.physicalForm.name,
        couponId: this.physicalForm.region,
        isGoodManage: 1,
        singleAmount: 1,
        pointActivityPrizeRemark: this.withOrderForm.pointActivityPrizeRemark,
        giftType: "1",
        budgetRemain:
          this.physicalForm.inventoryType == 1
            ? ""
            : this.physicalForm.budgetRema
      };
      this.dialogVisibleFrom = false;
      this.jingDonEka(14, 1);
    },
    nameStr(type, val) {
      let obj = {};
      if (type == 1) {
        obj = {
          2: "1元京东E卡",
          3: "5元京东E卡",
          4: "20元京东E卡",
          5: "50元京东E卡",
          6: "100元京东E卡",
        };
      }
      if (type == 2) {
        obj = {
          7: "PLUS会员年卡",
        };
      }
      if (type == 3) {
        obj = {
          8: "爱奇艺会员月卡",
          12: "爱奇艺会员季卡",
          13: "爱奇艺会员半年卡",
          14: "爱奇艺会员年卡",
        };
      }
      return obj[val];
    },
    jingDonEka(type, isGoodManage) {
      let item;
      if (type == 8) {
        item = this.redSelectList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      } else if (type == 10) {
        item = this.giftCardList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      } else if ((type == 3||type==14) && isGoodManage == 1) {
        item = this.physicalList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      } else {
        item = this.eKselectList.find((i) => {
          return i.id == this.zcData.couponId;
        });
      }
      if (this.num == 2) {
        if (item) {
          // 梯度奖励
          if (this.$parent.ruleForm.isCumulativePrize) {
            let line =
              this.$parent.ruleForm.isCumulativePrize == 1
                ? this.$parent.tableData[this.$parent.tableIndex]
                : this.$parent.taskTableData[this.$parent.taskTableIndex];
            if (
              line.prizeCount &&
              Number(line.prizeCount) > Number(item.budgetRemain)
            ) {
              this.messageLog(type);
              return;
            }
          } else {
            if (
              Number(this.$parent.ruleForm.prizeCount) &&
              Number(this.$parent.ruleForm.prizeCount) >
                Number(item.budgetRemain)
            ) {
              this.messageLog(type);
              return;
            }
          }
        }
      } else {
        let line = this.JingdouCount;
        if (item&&type!=3) {
          if (
            line.prizeCount &&
            Number(line.prizeCount) > Number(item.budgetRemain)
          ) {
            this.messageLog(type);
            return;
          }
        }
      }
      this.dialogVisibleFrom = false;
      if (type == 8) {
        this.$emit(
          "choose-shop",
          { ...this.zcData, name: `${this.zcData.discount}元现金红包` },
          8
        );
      } else {
        this.$emit("choose-shop", { ...this.zcData }, type);
      }
    },
    messageLog(type) {
      if (type == 5)
        this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！");
      if (type == 6)
        this.$message.error(
          "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
        );
      if (type == 7)
        this.$message.error(
          "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
        );
      if (type == 8)
        this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！");
      if (type == 10)
        this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额");
    },
    redList() {
      this.dialogVisibleFrom = false;
      this.$emit(
        "choose-shop",
        { ...this.zcData, name: `${this.zcData.discount}元现金红包` },
        8
      );
    },
    //上传图片
    handleChange(file, fileList) {
      console.log(file, fileList);
      const isLt3M = file.size < 1024 * 300;
      let sorts = [".jpg", ".png", ".jpeg"];
      let fileExtensions = sorts.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else if (!fileExtensions) {
        this.$message.error("请上传png.jpg.jpeg格式的图片");
        this.$refs.upload.clearFiles();
      } else {
        this.fileList = [];
        let target = fileList[1];
        this.fileList.push(target);
        // this.fileList = fileList;

        // this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          if (this.activeName == "second") {
            this.secondLogo = res.data;
          } else if (this.activeName == "four") {
            this.fourLogo = res.data;
          } else if (this.activeName == "fird") {
            this.firdLogo = res.data;
          } else if (this.activeName == "six") {
            this.sixLogo = res.data;
          } else if (this.activeName == "sev") {
            this.sevLogo = res.data;
          } else if (this.activeName == "eig") {
            this.eigLogo = res.data;
          } else if (this.activeName == "nine") {
            this.nineLogo = res.data;
          } else if (this.activeName == "eleven") {
            this.exclusivePriceForm.logo = res.data;
          } else if (this.activeName == "twelve") {
            this.tokenForm.logo = res.data;
          } else if (this.activeName == "thirteen") {
            this.withOrderForm.logo = res.data;
          }else {
            this.objectForm.logo = res.data;
          }
        });
      }
    },

    handleRemove(file, fileList) {
      this.fileList = [];
      this.$refs.upload.clearFiles();
      // this.imageName = "";
      // this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    httpRequest() {},
    //分页事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handlePageChangeTwo(val) {
      this.formListTwo.size = val.pageSize;
      this.formListTwo.current = val.pageNum;
      this.querySellerCouponExternal();
    },
    handleSizeChangeTwo(val) {
      this.formListTwo.size = val;
      this.querySellerCouponExternal();
    },
    handleCurrentChangeTwo(val) {
      this.formListTwo.current = val;
      this.querySellerCouponExternal();
    },
    //分页事件
    handleSizeChangeThr(val) {
      this.formShopList.size = val;
      this.getShopList();
    },
    handlePage(val) {
      this.formShopList.size = val.pageSize;
      this.formShopList.current = val.pageNum;
      this.getShopList();
    },
    handleCurrentChangeThr(val) {
      this.formShopList.current = val;
      this.getShopList();
    },
    //奖品介绍图片上传
    beforeUpload(file) {
      console.log(file);
      if (this.introducePicUrl.length >= 20) {
        this.$message.info("最多可上传20张");
        return false;
      } else if (this.physicalForm.introducePicUrl.length >= 20) {
        this.$message.info("最多可上传20张");
        return false;
      }
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.src = _URL.createObjectURL(file);
      // const isLt3M = file.size <= 300 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      // if (!isLt3M) {
      //   this.$message.info("图片大小不符合要求，请重新上传");
      //   return false;
      // }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("图片格式不符合要求，请重新上传");
        return false;
      }
    },
    handleUpload(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        if (this.introducePicUrl.length >= 20) {
          this.$message.info("最多可上传20张");
          return false;
        } else {
          if (this.isShowFirst) {
            // A2定制
            this.physicalForm.introducePicUrl.push(res.data);
          } else {
            this.introducePicUrl.push(res.data);
          }
        }
      }
    },
    //删除
    delec(index) {
      this.introducePicUrl.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.uploadButton {
  border-color: #1f1f1f;
  color: #1f1f1f;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  width: 148px;
  height: 148px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #8c939d;
  overflow: hidden;
}

.coupon-tip-wrap {
  margin-bottom: 10px;
}
.Notetake {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.topTis {
  display: flex;
  align-items: baseline;
  color: #333;
  font-size: 14px;
  background: #f4f7ff;
  margin: 24px;
  padding: 12px;
  color: #333;
  margin-left: 0px;
  .desc {
    line-height: 20px;
  }
  p {
    margin-left: 5px;
    line-height: 20px;
  }
  .topTis_line {
    line-height: 25px;
    font-size: 12px;
  }
}
.cancel {
  width: 164px;
  // margin-right: 8px;
  color: #fe4d45;
  border: 1px solid #fe4d45;
  background: rgba(254, 77, 69, 0.1);
  // &:hover {
  //   color: #fe4d45;
  //   border: 1px solid #fe4d45;
  //   background: rgba(123, 97, 255, 0.1);
  // }
}
/deep/.el-dialog--center {
  text-align: left;
}
.elImg {
  width: 120px;
  height: 120px;
  border: 1px dashed #dddddd;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-slot {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  text-align: center;
  padding-top: 43px;

  i {
    font-size: 30px;
    color: #909399;
  }
}
.select-disabled {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background: #000;
  z-index: 9;
  opacity: 0;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
.mb15 {
  margin-bottom: 15px;
}
.mt12 {
  margin-top: 12px;
}

.with-order-tab {
  position: relative;
}

.order-box {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
}

.mlr8 {
  margin: 0 8px;
}

.physical-box {
  overflow: auto;
  max-height: 555px;
}

.footer-btn {
  position: absolute;
  bottom: 0;
  text-align: right;
}

.req-tips {
  width: 92%;
  font-size: 14px;
  line-height: 14px;
  color: #FF7F23;
  line-height: normal;
}
.red-tips {
  margin-top: 12px;
  font-size: 14px;
  color: #FF4D4F;
  line-height: normal;
}
.flex-box {
  display: flex;
  align-items: center;
}
.question-icon {
  color: #333333;
  display: inline-flex;
  align-items: center;

  img {
    cursor: pointer;
    width: 18px;
    height: 18px;
  }
}
.time-box {
  padding: 8px 0;
}
.sel-w {
  width: 125px;
}
.mt8 {
  margin-top: 8px;
}
.label-style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 110px;
}
.link-tip {
  color: #f56c6c;
  margin-left: 120px;
  margin-top: 16px;
}
.req-style {
  color: #f56c6c;
}
</style>
